import React, { useState, useEffect, useContext, Fragment } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import Select from 'react-select';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import moment from 'moment';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import DatePicker, { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import { Form, Col } from 'react-bootstrap';
import AddButton from '../../../components/AddButton';
import Button from '../../../components/Button';
import GenericButton from '../../../components/FlowGenericButton';
import EditButton from '../../../components/EditButton';
import Fieldset from '../../../components/Fieldset';
import Modal from '../../../components/Modal';
import If from '../../../components/If';
import AlertError from '../../../components/AlertError';
import AlertSuccess from '../../../components/AlertSuccess';
import DeleteButton from '../../../components/DeleteButton';
import LoadingInForm from '../../../components/LoadingInForm';
import ConfirmationModal from '../../../components/ConfirmationModal';
import { STRINGS } from '../../../util/strings';
import { isEmptyObj } from '../../../functions/isEmptyObject';
import { Context } from '../../../context/AuthContext'
import { DecodedToken } from '../../../models/user';
import '../../../pages/Registers/styles.css';
import api, { apiFileDownload } from '../../../services/api';
import jwtDecode from 'jwt-decode';
import { DecimalAsComma } from '../NumberFormat';
import { _generateDate } from '../../../util/convert';
import '../styles_add.scss';
import FileExistent from '../../../components/FileExistent';
import * as Models from '../../../models/models';

import { STRINGS_CADERNOCONFORMIDADE } from '../../../util/cadernoConformidade/string';
import LinkVisualizarAutorizacao from './LinkAutorizacao';

import { isAdmin } from '../../../users/CadernoConformidade/isAdmin';
import { isRequesterReader, isRequesterWriter } from '../../../users/CadernoConformidade/isRequester';
import { isReguladorWriter, isReguladorReader } from '../../../users/CadernoConformidade/isRegulador';

import { STATUS_CADERNOCONFORMIDADE, isCriacaoEmAnaliseRegulatorio, podeRequisitanteSolicitarCriacaoCaderno } from '../../../util/cadernoConformidade/status';

import {
	StateType, Enum, VegetacaoSearchResult, CulturaResult,
	ResponsavelRegulatorioResult, TecnicoPrincipalResult,
	VegetacaoAnotacoes, VegetacaoPlantios, VegetacaoDataPlantios, VegetacaoPessoasEnvolvidasPlantio, VegetacaoPessoasEnvolvidasColheita,
	VegetacaoResponsaveisDescarte, VegetacaoLimpezaDestruicao, VegetacaoDataColheita, VegetacaoRegistroAmostragem, VegetacaoAtividadeManutencao,
	VegetacaoInspecaoEquipamentos, VegetacaoLimpezaInstalacoes,
	ExpectedDocumentos, ExpectedRegistroAmostragem, ExpectedPlanejamento,
	ExpectedPlanejamentoConducao, ExpectedReportes, ExpectedAnotacoes,
	ExpectedDestruicao, ExpectedDatasPlantio, ExpectedPessoasEnvolvidasPlantio,
	ExpectedDatasColheita, ExpectedPessoasEnvolvidasColheita,
	ExpectedAtividades, ExpectedInspecao, ExpectedLimpeza, ExpectedDestruicaoResponsaveis,
	ExpectedDestruicaoLimpeza, ExpectedPlanejamentoNotificacaoPlantio,
	Documentos_PastaProcessoOnEditVegetacao,
} from '../../../models/modelsCadernoConformidade';

registerLocale('pt-BR', ptBR);

export default function CadernoConformidade() {
	const history = useHistory();
	const location = useLocation<StateType>();
	const { token } = useContext(Context);
	const decoded: DecodedToken = jwtDecode(token.access_token);
	const { roles, unique_name }: DecodedToken = jwtDecode(token.access_token);
	const [statusCadernoConformidade, setStatusCadernoConformidade] = useState<number>();
	//Loading screen
	const [loading, setLoading] = useState<string[]>([]);
	const setLoadingScreen = (tag: string, type: boolean = true) => {

		let currentLoading = loading;
		let index = currentLoading.indexOf(tag);

		if (type) {
			if (index >= 0)
				return;

			currentLoading.push(tag);
		}
		else {
			if (index <= -1)
				return;

			currentLoading.splice(index, 1);
		}

		setLoading([]);
		setLoading(currentLoading);
	}
	const isLoadingScreen = (tag: string): boolean => { return loading.indexOf(tag) >= 0; }
	const [requisitanteCadernoConformidade, setRequisitanteCadernoConformidade] = useState('');
	const [dataCriacaoCadernoConformidade, setDataCriacaoCadernoConformidade] = useState(''); 
	const [entity, setEntity] = useState<VegetacaoSearchResult>({
		id: 0,
		codigoaac: '',
		projeto: '',
		municipio_Id: 0,
		municipioEntidade: {
			label: "",
			value: 0,
		},
		cultura_Id: 0,
		culturaEntidade: {
			label: "",
			value: 0,
		},
		nomecientifico: '',
		nomecientifico_Id: 0,
		numeromapa: '',
		responsavelRegulatorio_Id: 0,
		responsavelRegulatorioEntidade: {
			label: "",
			value: 0,
		},
		tecnicoPrincipal_Id: 0,
		tecnicoPrincipalEntidade: {
			label: "",
			value: 0,
		},
		status: '',
		dataCriacao: '',
		requisitante: '',
	});

	const [tipoDestruicaoValue, setTipoDestruicaoValue] = useState<any>(0);
	const [localDestruicaoValue, setLocalDestruicaoValue] = useState<any>(0);
	const [metodoDestruicaoValue, setMetodoDestruicaoValue] = useState<any>(0);

	const [contagemAnotacao, setContagemAnotacao] = useState<any>(null);
	const [anotacaoEdit, setAnotacaoEdit] = useState<VegetacaoAnotacoes>({
		id: 0,
		responsavel: '',
		dataAnotacao: undefined,
		anotacao: '',
	});
	const [selectedAnotacoes, setSelectedAnotacoes] = useState<VegetacaoAnotacoes[]>([]);
	const [modalAnotacoes, setModalAnotacoes] = useState<boolean>(false);

	const [plantioEdit, setPlantioEdit] = useState<VegetacaoPlantios>({
		id: 0,
		numeroPlantio: 0,
		casaVegetacaoModulo: '',
		material: '',
		informacoesAdicionaisMaterial: '',
		numeroAMI: '',
		sobraMaterial: '',
		numeroAmostrasRestantes: '',
		quantidadeAmostrasRestantes: '',
		destinoSobra: '',
		entradaArmazenamento: '',
		informacoesAdicionais: '',
		dataInicialPlantio: '',
		dataFinalPlantio: '',

	});
	const [selectedPlantios, setSelectedPlantios] = useState<VegetacaoPlantios[]>([]);
	const [modalPlantios, setModalPlantios] = useState<boolean>(false);

	const [contagemRegistroAmostragem, setContagemRegistroAmostragem] = useState<any>(null);

	const [registroAmostragemEdit, setRegistroAmostragemEdit] = useState<VegetacaoRegistroAmostragem>({
		id: 0,
		contagemRegistroAmostragem: '',
		dataInicialAmostragem: '',
		dataFinalAmostragem: '',
		tipoMaterialAmostragem: '',
		responsavelAmostragem: '',
		destinoAmostras: '',
		filename: '',
	});
	const [selectedRegistroAmostragem, setSelectedRegistroAmostragem] = useState<VegetacaoRegistroAmostragem[]>([]);
	const [modalRegistroAmostragem, setModalRegistroAmostragem] = useState<boolean>(false);

	const [dataPlantioEdit, setDataPlantioEdit] = useState<VegetacaoDataPlantios>({
		id: 0,
		dataInicialPlantio: '',
		dataFinalPlantio: '',
	});
	const [selectedDataPlantios, setSelectedDataPlantios] = useState<VegetacaoDataPlantios[]>([]);
	const [modalDataPlantios, setModalDataPlantios] = useState<boolean>(false);

	const [contagemPessoasEnvolvidasPlantio, setContagemPessoasEnvolvidasPlantio] = useState<any>(null);

	const [PessoasEnvolvidasPlantioEdit, setPessoasEnvolvidasPlantioEdit] = useState<VegetacaoPessoasEnvolvidasPlantio>({
		id: 0,
		contagemPessoasEnvolvidasPlantio: '',
		pessoaPlantio: ''
	});
	const [selectedPessoasEnvolvidasPlantio, setSelectedPessoasEnvolvidasPlantio] = useState<VegetacaoPessoasEnvolvidasPlantio[]>([]);
	const [modalPessoasEnvolvidasPlantio, setModalPessoasEnvolvidasPlantio] = useState<boolean>(false);

	const [eventMsg, setEventsMsg] = useState('');

	const [lblDocumentosGerais, setLblDocumentosGerais] = useState('Escolher arquivo');
	const [documentosGerais, setDocumentosGerais] = useState<any[]>([]);

	const [lblDadosPrincipaisAAC, setLblDadosPrincipaisAAC] = useState('Escolher arquivo');
	const [dadosPrincipaisAAC, setDadosPrincipaisAAC] = useState<any[]>([]);
	const [fileFieldDadosPrincipaisAAC, setFileFieldDadosPrincipaisAAC] = useState<Models.ModelFileRegister>();

	const [lblDadosPrincipaisListaTreinamento, setLblDadosPrincipaisListaTreinamento] = useState('Escolher arquivo');
	const [dadosPrincipaisListaTreinamento, setDadosPrincipaisListaTreinamento] = useState<any[]>([]);

	const [lblDadosPrincipaisParecerTecnico, setLblDadosPrincipaisParecerTecnico] = useState('Escolher arquivo');
	const [dadosPrincipaisParecerTecnico, setDadosPrincipaisParecerTecnico] = useState<any[]>([]);
	const [fileFieldDadosPrincipaisParecerTecnico, setFileFieldDadosPrincipaisParecerTecnico] = useState<Models.ModelFileRegister>();

	const [lblDadosPrincipaisLiberacaoQuarentena, setLblDadosPrincipaisLiberacaoQuarentena] = useState('Escolher arquivo');
	const [dadosPrincipaisLiberacaoQuarentena, setDadosPrincipaisLiberacaoQuarentena] = useState<any[]>([]);

	const [lblPlanejamentoCroqui, setLblPlanejamentoCroqui] = useState('Escolher arquivo');
	const [planejamentoCroqui, setPlanejamentoCroqui] = useState<any[]>([]);

	const [lblNumeroAMI, setLblNumeroAMI] = useState('Escolher arquivo');
	const [numeroAMI, setNumeroAMI] = useState<any[]>([]);
	const [modalAtivo, setModalAtivo] = useState<string>('');

	const [lblNumeroAAC, setLblNumeroAAC] = useState('Escolher arquivo');
	const [numeroAAC, setNumeroAAC] = useState<any[]>([]);

	const [lblArquivoRegistroAmostragem, setLblArquivoRegistroAmostragem] = useState('Escolher arquivo');

	const [contagemLimpezaDestruicao, setContagemLimpezaDestruicao] = useState<any>(null);

	const [limpezaDestruicaoEdit, setLimpezaDestruicaoEdit] = useState<VegetacaoLimpezaDestruicao>({
		id: 0,
		contagemLimpezaDestruicao: '',
		descricaoMaquinario: '',
		dataLimpezaAntesUso: '',
		dataLimpezaDepoisUso: '',
		metodoLimpeza: '',
		responsavelLimpeza: '',
	});
	const [selectedLimpezaDestruicao, setSelectedLimpezaDestruicao] = useState<VegetacaoLimpezaDestruicao[]>([]);
	const [modalLimpezaDestruicao, setModalLimpezaDestruicao] = useState<boolean>(false);

	const [selectedDatasColheita, setSelectedDatasColheita] = useState<VegetacaoDataColheita[]>([]);
	const [modalDatasColheita, setModalDatasColheita] = useState<boolean>(false);

	const [contagemPessoasEnvolvidasColheita, setContagemPessoasEnvolvidasColheita] = useState<any>(null);

	const [PessoasEnvolvidasColheitaEdit, setPessoasEnvolvidasColheitaEdit] = useState<VegetacaoPessoasEnvolvidasColheita>({
		id: 0,
		contagemPessoasEnvolvidasColheita: '',
		pessoaColheita: ''
	});
	const [selectedPessoasEnvolvidasColheita, setSelectedPessoasEnvolvidasColheita] = useState<VegetacaoPessoasEnvolvidasColheita[]>([]);
	const [modalPessoasEnvolvidasColheita, setModalPessoasEnvolvidasColheita] = useState<boolean>(false);

	const [contagemResponsaveisDescarte, setContagemResponsaveisDescarte] = useState<any>(null);

	const [ResponsaveisDescarteEdit, setResponsaveisDescarteEdit] = useState<VegetacaoResponsaveisDescarte>({
		id: 0,
		contagemResponsaveisDescarte: '',
		responsaveisDescarte: ''
	});
	const [selectedResponsaveisDescarte, setSelectedResponsaveisDescarte] = useState<VegetacaoResponsaveisDescarte[]>([]);
	const [modalResponsaveisDescarte, setModalResponsaveisDescarte] = useState<boolean>(false);


	const [contagemInspecaoEquipamento, setContagemInspecaoEquipamento] = useState<any>(null);

	const [inspecaoEquipamentosEdit, setInspecaoEquipamentosEdit] = useState<VegetacaoInspecaoEquipamentos>({
		id: 0,
		contagemInspecaoEquipamento: '',
		numeroPlantio: '',
		iD_Equipamento: '',
		dataAntesUso: '',
		dataAposUso: '',
		faseEnsaio: '',
		metodoLimpezaEquipamento_Id: '',
		faseLimpeza_Id: '',

	});
	const [selectedInspecaoEquipamentos, setSelectedInspecaoEquipamentos] = useState<VegetacaoInspecaoEquipamentos[]>([]);
	const [modalInspecaoEquipamentos, setModalInspecaoEquipamentos] = useState<boolean>(false);

	const [contagemLimpezaInstalacao, setContagemLimpezaInstalacao] = useState<any>(null);

	const [limpezaInstalacoesEdit, setLimpezaInstalacoesEdit] = useState<VegetacaoLimpezaInstalacoes>({
		id: 0,
		contagemLimpezaInstalacao: '',
		dataLimpeza: '',
		numeroCodigoCasaVegetacao: '',
		responsavel: '',
		metodoLimpeza_Id: '',
	});
	const [selectedLimpezaInstalacoes, setSelectedLimpezaInstalacoes] = useState<VegetacaoLimpezaInstalacoes[]>([]);
	const [modalLimpezaInstalacoes, setModalLimpezaInstalacoes] = useState<boolean>(false);

	const [contagemAtividadeManutencao, setContagemAtividadeManutencao] = useState<any>(null);

	const [atividadeManutencaoEdit, setAtividadeManutencaoEdit] = useState<VegetacaoAtividadeManutencao>({
		id: 0,
		contagemAtividadeManutencao: '',
		dataAtividade: '',
		responsavel: '',
		atividadeManutencao_Id: '',
		dataInicialAtividade: '',
		dataFinalAtividade: '',

	});
	const [selectedAtividadeManutencao, setSelectedAtividadeManutencao] = useState<VegetacaoAtividadeManutencao[]>([]);
	const [modalAtividadeManutencao, setModalAtividadeManutencao] = useState<boolean>(false);

	const [isConfirmation, setIsConfirmation] = useState<boolean>(false);
	const [loadingDraft, setLoadingDraft] = useState<boolean>(false);
	const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
	const [loadingGetData, setLoadingGetData] = useState<boolean>(true);
	const [successSubmit, setSuccessSubmit] = useState<boolean>(false);
	const [successDraft, setSuccessDraft] = useState<boolean>(false);
	const [errorSubmit, setErrorSubmit] = useState<any>(null);
	const [errorDraft, setErrorDraft] = useState<any>(null);
	const [errorGetData, setErrorGetData] = useState<any>(null);
	const [isCorrection, setIsCorrection] = useState<boolean>(false);
	const [reasonCorrection, setReasonCorrection] = useState('');
	const [loadingCorrection, setLoadingCorrection] = useState<boolean>(false);
	const [successCorrection, setSuccessCorrection] = useState<boolean>(false);
	const [isApprove, setIsApprove] = useState<boolean>(false);
	const [loadingApprove, setLoadingApprove] = useState<boolean>(false);
	const [successApprove, setSuccessApprove] = useState<boolean>(false);


	const vegetacaoSchema = yup.object({
		codigoaac: yup.mixed().required(STRINGS.FORM_FIELD_REQUIRED),
		projeto: yup.string().required(STRINGS.FORM_FIELD_REQUIRED),
		municipio: yup.mixed().required(STRINGS.FORM_FIELD_REQUIRED),
		cultura_Id: yup.string().required(STRINGS.FORM_FIELD_REQUIRED),
		modoDeTransporte: yup.mixed().required(STRINGS.FORM_FIELD_REQUIRED),
		nomecientifico: yup.string().required(STRINGS.FORM_FIELD_REQUIRED),
		numeromapa: yup.string().required(STRINGS.FORM_FIELD_REQUIRED),
		responsavelRegulatorio_Id: yup.mixed().required(STRINGS.FORM_FIELD_REQUIRED),
		tecnicoPrincipal_Id: yup.mixed().required(STRINGS.FORM_FIELD_REQUIRED)

	});

	const initialValues: VegetacaoSearchResult = {
		id: 0,
		codigoaac: '',
		projeto: '',
		municipio_Id: 0, 
		municipioEntidade: {
			label:"",
			value:0,
		},
		cultura_Id: 0, 
		culturaEntidade: {
			label: "",
			value: 0,
		},
		nomecientifico: '',
		nomecientifico_Id: 0,
		numeromapa: '',
		responsavelRegulatorio_Id: 0, 
		responsavelRegulatorioEntidade: {
			label: "",
			value: 0,
		},
		tecnicoPrincipal_Id: 0, 
		tecnicoPrincipalEntidade: {
			label: "",
			value: 0,
		},
		status: '',
		dataCriacao: '',
		requisitante: '',
	}

	//const { getValues: getValuesEvent, control: controlEvent, register: registerEvent, errors: errorsEvent, handleSubmit: handleSubmitEvent, trigger: triggerEvent, watch: watchEvent } = useForm({
	//	mode: 'all',
	//	//resolver: yupResolver(tipoMaterialDescarteSchema)
	//})

	const { register, getValues, errors, trigger, handleSubmit, control, watch, formState: { isDirty } } = useForm({
		defaultValues: initialValues,
		mode: 'onSubmit',
		resolver: yupResolver(vegetacaoSchema)
	});

	const { getValues: getValuesAnotacoes, control: controlAnotacoes, register: registerAnotacoes, errors: errorsAnotacoes, handleSubmit: handleSubmitAnotacoes, trigger: triggerAnotacoes, watch: watchAnotacoes } = useForm({
		mode: 'all',
		//resolver: yupResolver(AnotacoesSchema)
	})

	const { getValues: getValuesPlantios, control: controlPlantios, register: registerPlantios, errors: errorsPlantios, handleSubmit: handleSubmitPlantios, trigger: triggerPlantios, watch: watchEditPlantios } = useForm({
		mode: 'all',
		//resolver: yupResolver(PlantiosSchema)
	})

	const { getValues: getValuesRegistroAmostragem, control: controlRegistroAmostragem, register: registerRegistroAmostragem, errors: errorsRegistroAmostragem, handleSubmit: handleSubmitRegistroAmostragem, trigger: triggerRegistroAmostragem, watch: watchEditRegistroAmostragem } = useForm({
		mode: 'all',
		//resolver: yupResolver(RegistroAmostragemsSchema)
	})

	const { getValues: getValuesDataPlantios, control: controlDataPlantios, register: registerDataPlantios, errors: errorsDataPlantios, handleSubmit: handleSubmitDataPlantios, trigger: triggerDataPlantios, watch: watchDataPlantios } = useForm({
		mode: 'all',
		//resolver: yupResolver(PlantiosSchema)
	})

	const { getValues: getValuesPessoasEnvolvidasPlantio, control: controlPessoasEnvolvidasPlantio, register: registerPessoasEnvolvidasPlantio, errors: errorsPessoasEnvolvidasPlantio, handleSubmit: handleSubmitPessoasEnvolvidasPlantio, trigger: triggerPessoasEnvolvidasPlantio, watch: watchPessoasEnvolvidasPlantio } = useForm({
		mode: 'all',
		//resolver: yupResolver(PlantiosSchema)
	})

	const { getValues: getValuesLimpezaDestruicao, control: controlLimpezaDestruicao, register: registerLimpezaDestruicao, errors: errorsLimpezaDestruicao, handleSubmit: handleSubmitLimpezaDestruicao, trigger: triggerLimpezaDestruicao, watch: watchEditLimpezaDestruicao } = useForm({
		mode: 'all',
		//resolver: yupResolver(LimpezaDestruicaochema)
	})

	const { getValues: getValuesDatasColheita, control: controlDatasColheita, register: registerDatasColheita, errors: errorsDatasColheita, handleSubmit: handleSubmitDatasColheita, trigger: triggerDatasColheita, watch: watchDatasColheita } = useForm({
		mode: 'all',
		//resolver: yupResolver(DatasColheitachema)
	})

	const { getValues: getValuesPessoasEnvolvidasColheita, control: controlPessoasEnvolvidasColheita, register: registerPessoasEnvolvidasColheita, errors: errorsPessoasEnvolvidasColheita, handleSubmit: handleSubmitPessoasEnvolvidasColheita, trigger: triggerPessoasEnvolvidasColheita, watch: watchPessoasEnvolvidasColheita } = useForm({
		mode: 'all',
		//resolver: yupResolver(ColheitasSchema)
	})

	const { getValues: getValuesResponsaveisDescarte, control: controlResponsaveisDescarte, register: registerResponsaveisDescarte, errors: errorsResponsaveisDescarte, handleSubmit: handleSubmitResponsaveisDescarte, trigger: triggerResponsaveisDescarte, watch: watchResponsaveisDescarte } = useForm({
		mode: 'all',
		//resolver: yupResolver(ColheitasSchema)
	})

	const { getValues: getValuesInspecaoEquipamentos, control: controlInspecaoEquipamentos, register: registerInspecaoEquipamentos, errors: errorsInspecaoEquipamentos, handleSubmit: handleSubmitInspecaoEquipamentos, trigger: triggerInspecaoEquipamentos, watch: watchEditInspecaoEquipamentos } = useForm({
		mode: 'all',
		//resolver: yupResolver(InspecaoEquipamentoschema)
	})

	const { getValues: getValuesLimpezaInstalacoes, control: controlLimpezaInstalacoes, register: registerLimpezaInstalacoes, errors: errorsLimpezaInstalacoes, handleSubmit: handleSubmitLimpezaInstalacoes, trigger: triggerLimpezaInstalacoes, watch: watchEditLimpezaInstalacoes } = useForm({
		mode: 'all',
		//resolver: yupResolver(LimpezaInstalacoeschema)
	})

	const { getValues: getValuesAtividadeManutencao, control: controlAtividadeManutencao, register: registerAtividadeManutencao, errors: errorsAtividadeManutencao, handleSubmit: handleSubmitAtividadeManutencao, trigger: triggerAtividadeManutencao, watch: watchEditAtividadeManutencao } = useForm({
		mode: 'all',
		//resolver: yupResolver(AtividadeManutencaosSchema)
	})

	const MODO_VIEW = {
		DADOS_PRINCIPAIS: 1,
		PLANEJAMENTO: 2,
		DESCARTE: 3,
		NOTAS: 4,
	}

	const [modoFluxo, setModoFluxo] = useState<Number>(MODO_VIEW.DADOS_PRINCIPAIS);
	const [cultures, setCultures] = useState<CulturaResult[]>([]);
	const [responsaveis, setResponsaveis] = useState<ResponsavelRegulatorioResult[]>([]);
	const [tecnicoPrincipal, setTecnicoPrincipal] = useState<TecnicoPrincipalResult[]>([]);

	const defaultForm = useForm({
		defaultValues: entity as any,
		mode: "onSubmit",
	});

	const aplicarDocumentosNoForm = (doc: any) => {
		if (!doc) return;
		defaultForm.setValue('copiaAAC', !!doc.copiaAAC);
		defaultForm.setValue('observacoesCopiaAAC', doc.observacoesCopiaAAC ?? '');
		defaultForm.setValue('copiaListaTreinamentos', !!doc.copiaListaTreinamentos);
		defaultForm.setValue('observacoesCopiaListaTreinamentos', doc.observacoesCopiaListaTreinamentos ?? '');
		defaultForm.setValue('copiaParecerTecnicoCTNBio', !!doc.copiaParecerTecnicoCTNBio);
		defaultForm.setValue('observacoesCopiaCTNBio', doc.observacoesCopiaCTNBio ?? doc.observacoesCopiaParecerTecnicoCTNBio ?? '');
		defaultForm.setValue('copiaQuarentena', !!doc.copiaQuarentena);
		defaultForm.setValue('observacoesCopiaQuarentena', doc.observacoesCopiaQuarentena ?? '');
		defaultForm.setValue('croquiExperimental', !!doc.croquiExperimental);
		defaultForm.setValue('observacoesCroquiExperimental', doc.observacoesCroquiExperimental ?? '');
		defaultForm.setValue('cienciaInstrucoes', !!doc.cienciaInstrucoes);
	};

	const renderCheckboxField = (name: string, label: string) => (
		<Controller
			name={name}
			control={defaultForm.control}
			render={({ onChange, value, ref }) => (
				<Form.Check
					type="checkbox"
					label={label}
					checked={!!value}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}
					ref={ref}
				/>
			)}
		/>
	);

	const [gridProps, setGridProps] = useState<any>(null);
	const [isRegulatory, setIsRegulatory] = useState<boolean>(false);


	const [enumTipoMaterialAmostragem, setEnumTipoMaterialAmostragem] = useState<Enum[]>([]);
	const [enumDestinoAmostras, setEnumDestinoAmostras] = useState<Enum[]>([]);
	const [enumDestinoSobra, setEnumDestinoSobra] = useState<Enum[]>([]);
	const [enumLocalDescarte, setEnumLocalDescarte] = useState<Enum[]>([]);
	const [enumMetodoDescarte, setEnumMetodoDescarte] = useState<Enum[]>([]);
	const [enumTipoMaterialDescartado, setEnumTipoMaterialDescartado] = useState<Enum[]>([]);
	const [enumTipoColheita, setEnumTipoColheita] = useState<Enum[]>([]);
	const [enumMetodoLimpeza, setEnumMetodoLimpeza] = useState<Enum[]>([]);
	const [enumMetodoLimpezaEquipamento, setEnumMetodoLimpezaEquipamento] = useState<Enum[]>([]);
	const [enumMetodoLimpezaInstalacao, setEnumMetodoLimpezaInstalacao] = useState<Enum[]>([]);
	const [enumMunicipio, setEnumMunicipio] = useState<Enum[]>([]);
	const [enumNomeCientifico, setEnumNomeCientifico] = useState<Enum[]>([]);
	const [enumResponsavelRegulatorio, setEnumResponsavelRegulatorio] = useState<Enum[]>([]);
	const [enumAtividadesManutencao, setEnumAtividadesManutencao] = useState<Enum[]>([]);

	//inicio config modal upload ...
	const modalArquivo = useForm({
		mode: 'onSubmit',
		resolver: yupResolver(yup.object({
			arquivos: yup.mixed().required(STRINGS.FORM_FIELD_REQUIRED)
		})),
		shouldUnregister: false
	})
	//fim config modal upload ...

	const setValuesWithDataResponse = (data: any) => {

		defaultForm.setValue('codigoaac', data.codigoAAC);
		defaultForm.setValue('municipio', {
			label: data.municipioNome,
			value: data.municipio_Id,
		});
		defaultForm.setValue('cultura', {
			label: data.culturaNome,
			value: data.cultura_Id,
		});
		defaultForm.setValue('nomeCientifico', {
			label: data.nomeCientificoNome,
			value: data.nomeCientifico_Id,
		});

		defaultForm.setValue('numeroMAPA', data.numeroMapa);
		defaultForm.setValue('projeto', data.projeto);
		defaultForm.setValue('responsavelRegulatorio', {
			label: data.responsavelRegulatorioNome,
			value: data.responsavelRegulatorio_Id,
		});
		defaultForm.setValue('tecnicoPrincipal', {
			label: data.tecnicoPrincipalNome,
			value: data.tecnicoPrincipal_Id,
		});

		aplicarDocumentosNoForm(data?.vegetacao_Documentos?.[0]);

		// vegetacao_Dados_Principais_AAC
		setTimeout(() => {

			if (data?.vegetacao_DP_ArquivoAAC?.length) {
				setFileFieldDadosPrincipaisAAC(data.vegetacao_DP_ArquivoAAC);

				let newArquivos: Documentos_PastaProcessoOnEditVegetacao[] = [];

				for (let n = 0, t = data?.vegetacao_DP_ArquivoAAC?.length; n < t; n++) {
					let arquivo: Documentos_PastaProcessoOnEditVegetacao = {
						id: data.vegetacao_DP_ArquivoAAC[n].id,
						filename: data.vegetacao_DP_ArquivoAAC[n].filename,
						name: data.vegetacao_DP_ArquivoAAC[n].filename,
						codigo: data.vegetacao_DP_ArquivoAAC[n].codigo,
						path: data.vegetacao_DP_ArquivoAAC[n].path,
					};

					newArquivos.push(arquivo);
				}

				setDadosPrincipaisAAC(newArquivos);
			}
		}, 1500);

		// vegetacao_DadosPrincipais_Lista_Treinamentos
		setTimeout(() => {

			if (data?.vegetacao_DP_ArquivosListaTreinamento?.length) {

				let newArquivos: Documentos_PastaProcessoOnEditVegetacao[] = [];

				for (let n = 0, t = data?.vegetacao_DP_ArquivosListaTreinamento?.length; n < t; n++) {
					let arquivo: Documentos_PastaProcessoOnEditVegetacao = {
						id: data.vegetacao_DP_ArquivosListaTreinamento[n].id,
						filename: data.vegetacao_DP_ArquivosListaTreinamento[n].filename,
						name: data.vegetacao_DP_ArquivosListaTreinamento[n].filename,
						codigo: data.vegetacao_DP_ArquivosListaTreinamento[n].codigo,
						path: data.vegetacao_DP_ArquivosListaTreinamento[n].path,
					};

					newArquivos.push(arquivo);
				}

				setDadosPrincipaisListaTreinamento(newArquivos);
			}
		}, 1500);

		// vegetacao_Dados_Principais_ParecerTecnico
		setTimeout(() => {

			if (data?.vegetacao_DP_ArquivoUltimoParecer?.length) {
				setFileFieldDadosPrincipaisParecerTecnico(data.vegetacao_DP_ArquivoUltimoParecer);

				let newArquivos: Documentos_PastaProcessoOnEditVegetacao[] = [];

				for (let n = 0, t = data?.vegetacao_DP_ArquivoUltimoParecer?.length; n < t; n++) {
					let arquivo: Documentos_PastaProcessoOnEditVegetacao = {
						id: data.vegetacao_DP_ArquivoUltimoParecer[n].id,
						filename: data.vegetacao_DP_ArquivoUltimoParecer[n].filename,
						name: data.vegetacao_DP_ArquivoUltimoParecer[n].filename,
						codigo: data.vegetacao_DP_ArquivoUltimoParecer[n].codigo,
						path: data.vegetacao_DP_ArquivoUltimoParecer[n].path,
					};

					newArquivos.push(arquivo);
				}

				setDadosPrincipaisParecerTecnico(newArquivos);
			}
		}, 1500);

		// vegetacao_DadosPrincipais_Liberacao_Quarentena
		setTimeout(() => {

			if (data?.vegetacao_DP_ArquivoLiberacaoQuarentena?.length) {
				let newArquivos: Documentos_PastaProcessoOnEditVegetacao[] = [];

				for (let n = 0, t = data?.vegetacao_DP_ArquivoLiberacaoQuarentena?.length; n < t; n++) {
					let arquivo: Documentos_PastaProcessoOnEditVegetacao = {
						id: data.vegetacao_DP_ArquivoLiberacaoQuarentena[n].id,
						filename: data.vegetacao_DP_ArquivoLiberacaoQuarentena[n].filename,
						name: data.vegetacao_DP_ArquivoLiberacaoQuarentena[n].filename,
						codigo: data.vegetacao_DP_ArquivoLiberacaoQuarentena[n].codigo,
						path: data.vegetacao_DP_ArquivoLiberacaoQuarentena[n].path,
					};

					newArquivos.push(arquivo);
				}

				setDadosPrincipaisLiberacaoQuarentena(newArquivos);
			}
		}, 1500);

		setEntity(data);

		setStatusCadernoConformidade(data.status);

		setRequisitanteCadernoConformidade(data.requisitante);
	}

	useEffect(() => {

		const getDataToForm = async () => {

			try {
				const cultures = await api.get<CulturaResult[]>('api/v1/autorizacoes-cibio/Cultura/obterporfiltro?Ativo=true');

				const responsaveis = await api.get<ResponsavelRegulatorioResult[]>('api/v1/autorizacoes-cibio/Destinatario/obterporfiltro?Ativo=true');

				const tecnicos = await api.get<ResponsavelRegulatorioResult[]>('api/v1/autorizacoes-cibio/Destinatario/obterporfiltro?Ativo=true');

				const municipio = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/municipio');

				const nomeCientifico = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/nome-cientifico');

				const responsavelRegulatorio = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/responsavel-regulatorio');

				if (cultures.status === 200) {
					setCultures(cultures.data);
				}
				if (responsaveis.status === 200) {
					setResponsaveis(responsaveis.data);
				}
				if (tecnicos.status === 200) {
					setTecnicoPrincipal(tecnicos.data);
				}
				if (municipio.status === 200) {
					setEnumMunicipio(municipio.data);
				}
				if (nomeCientifico.status === 200) {
					setEnumNomeCientifico(nomeCientifico.data);
				}
				if (responsavelRegulatorio.status === 200) {
					setEnumResponsavelRegulatorio(responsavelRegulatorio.data);
				}
			}
			catch (error: any) {
				setErrorGetData(error?.response?.data);
			}

			setLoadingGetData(false);
		}

		getDataToForm();

		if (location.state && location.state.id) {
			getCadernoConformidade(location.state.id);
		}
		else {
			setStatusCadernoConformidade(0);
		}

	}, [location.state, defaultForm.reset]);

	useEffect(() => {
		aplicarDocumentosNoForm(entity?.vegetacao_Documentos?.[0]);
	}, [entity?.id, entity?.vegetacao_Documentos]);

	const getCadernoConformidade = async (entityId: any) => {

		setLoadingScreen('getCadernoConformidade');

		try {
			const { data, status } = await api.get<VegetacaoSearchResult>(`api/v1/caderno-conformidade/Vegetacao/${entityId}`);
			if (status === 200) {
				setValuesWithDataResponse(data);
				setEntity(data);
				setStatusCadernoConformidade(data.status);
				setDataCriacaoCadernoConformidade(data.dataCriacao);
			}
		} catch (error: any) {
			setErrorGetData(error.response.data);
		}

		setLoadingScreen('getCadernoConformidade', false);
	}

	const expectedDocumentos = (): ExpectedDocumentos[] => {
		const vegetacaoId = entity?.id ?? location.state?.id ?? 0;
		const documentoId = entity?.vegetacao_Documentos?.[0]?.id ?? 0;

		return [{
			Id: documentoId,
			cadernoConformidadeVegetacao_Id: vegetacaoId,
			copiaAAC: defaultForm.getValues('copiaAAC') ?? false,
			observacoesCopiaAAC: defaultForm.getValues('observacoesCopiaAAC') ?? '',
			copiaListaTreinamentos: defaultForm.getValues('copiaListaTreinamentos') ?? false,
			observacoesCopiaListaTreinamentos: defaultForm.getValues('observacoesCopiaListaTreinamentos') ?? '',
			copiaParecerTecnicoCTNBio: defaultForm.getValues('copiaParecerTecnicoCTNBio') ?? false,
			observacoesCopiaCTNBio: defaultForm.getValues('observacoesCopiaCTNBio') ?? '',
			copiaQuarentena: defaultForm.getValues('copiaQuarentena') ?? false,
			observacoesCopiaQuarentena: defaultForm.getValues('observacoesCopiaQuarentena') ?? '',
			copiaAMI: entity?.vegetacao_Documentos?.[0]?.copiaAMI ?? false,
			observacoesCopiaAMI: entity?.vegetacao_Documentos?.[0]?.observacoesCopiaAMI ?? '',
			croquiExperimental: defaultForm.getValues('croquiExperimental') ?? false,
			observacoesCroquiExperimental: defaultForm.getValues('observacoesCroquiExperimental') ?? '',
			cienciaInstrucoes: defaultForm.getValues('cienciaInstrucoes') ?? false,
			documentosDestino: defaultForm.getValues('documentosDestino') ?? false,
			observacoesDocumentosDestino: defaultForm.getValues('observacoesDocumentosDestino') ?? '',
			documentosAmostras: defaultForm.getValues('documentosAmostras') ?? false,
			observacoesDocumentosAmostras: defaultForm.getValues('observacoesDocumentosAmostras') ?? '',
			formulariosDestruicao: defaultForm.getValues('formulariosDestruicao') ?? false,
			observacoesFormulariosDestruicao: defaultForm.getValues('observacoesFormulariosDestruicao') ?? '',
			termosFiscalizacao: defaultForm.getValues('termosFiscalizacao') ?? false,
			observacoesTermosFiscalizacao: defaultForm.getValues('observacoesTermosFiscalizacao') ?? '',
		} as ExpectedDocumentos];
	}
	///* *//
	const expectedRegistroAmostragem = (): ExpectedRegistroAmostragem[] => {
		let arrRegistroAmostragem: ExpectedRegistroAmostragem[] = [];

		for (let count = 0, countLen = selectedRegistroAmostragem.length; count < countLen; count++) {
			arrRegistroAmostragem.push({
				Id: 0,
				dataInicial: selectedRegistroAmostragem[count].dataInicialAmostragem !== undefined ? selectedRegistroAmostragem[count].dataInicialAmostragem : '',
				dataFinal: selectedRegistroAmostragem[count].dataFinalAmostragem !== undefined ? selectedRegistroAmostragem[count].dataFinalAmostragem : '',
				tipoMaterial_Id: selectedRegistroAmostragem[count].tipoMaterialAmostragem !== undefined ? selectedRegistroAmostragem[count].tipoMaterialAmostragem.value : 0,
				outrosTipoMaterial: selectedRegistroAmostragem[count].tipoMaterialAmostragemOutros !== undefined ? selectedRegistroAmostragem[count].tipoMaterialAmostragemOutros : '',
				responsavel: selectedRegistroAmostragem[count].responsavelAmostragem !== undefined ? selectedRegistroAmostragem[count].responsavelAmostragem : '',
				destino: selectedRegistroAmostragem[count].destinoAmostras !== undefined ? selectedRegistroAmostragem[count].destinoAmostras.value : 0,
				outrosDestino: selectedRegistroAmostragem[count].destinoAmostrasOutros !== undefined ? selectedRegistroAmostragem[count].destinoAmostrasOutros : '',
				arquivoAmostragem: (selectedRegistroAmostragem[count].arquivoAmostragem !== null && selectedRegistroAmostragem[count].arquivoAmostragem !== '') ? selectedRegistroAmostragem[count].arquivoAmostragem : '',
				filename: (selectedRegistroAmostragem[count].filename !== null && selectedRegistroAmostragem[count].filename !== '') ? selectedRegistroAmostragem[count].filename : '',
			})
		}
		return arrRegistroAmostragem;
	}

	const expectedPlanejamento = (): ExpectedPlanejamento[] => {
		let arrPlanejamento: ExpectedPlanejamento[] = [];

		arrPlanejamento.push({
			Id: 0,
			treinamentoBiosseguranca: defaultForm.getValues('treinamentoBiosseguranca') !== undefined ? defaultForm.getValues('treinamentoBiosseguranca') : false,
			aacAprovada: defaultForm.getValues('aacAprovada') !== undefined ? defaultForm.getValues('aacAprovada') : false,
			documentacaoImportacao: defaultForm.getValues('documentacaoImportacao') !== undefined ? defaultForm.getValues('documentacaoImportacao') : false,
			deAcordoComPermissaoImportacao: defaultForm.getValues('deAcordoComPermissaoImportacao') !== undefined ? defaultForm.getValues('deAcordoComPermissaoImportacao') : false,
			materialIdentificacaoDisponivel: defaultForm.getValues('materialIdentificacaoDisponivel') !== undefined ? defaultForm.getValues('materialIdentificacaoDisponivel') : false,
			sementesConferidas: defaultForm.getValues('sementesConferidas') !== undefined ? defaultForm.getValues('sementesConferidas') : false,
			epIsDisponiveis: defaultForm.getValues('epIsDisponiveis') !== undefined ? defaultForm.getValues('epIsDisponiveis') : false,
		})

		return arrPlanejamento;
	}

	const expectedPlanejamentoConducao = (): ExpectedPlanejamentoConducao[] => {
		let arrPlanejamentoConducao: ExpectedPlanejamentoConducao[] = [];

		arrPlanejamentoConducao.push({
			Id: 0,
			ensaioConformidadeAACAprovada: defaultForm.getValues('ensaioConformidadeAACAprovada') !== undefined ? defaultForm.getValues('ensaioConformidadeAACAprovada') : false,
			observacoesEnsaioConformidadeAACAprovada: defaultForm.getValues('observacoesEnsaioConformidadeAACAprovada') !== undefined ? defaultForm.getValues('observacoesEnsaioConformidadeAACAprovada') : "",
			placaBiosseguranca: defaultForm.getValues('placaBiosseguranca') !== undefined ? defaultForm.getValues('placaBiosseguranca') : false,
			observacoesPlacaBiosseguranca: defaultForm.getValues('observacoesPlacaBiosseguranca') !== undefined ? defaultForm.getValues('observacoesPlacaBiosseguranca') : "",
			envelopesSementesDestruidos: defaultForm.getValues('envelopesSementesDestruidos') !== undefined ? defaultForm.getValues('envelopesSementesDestruidos') : false,
			observacoesEnvelopesSementesDestruidos: defaultForm.getValues('observacoesPlacaBiosseguranca') !== undefined ? defaultForm.getValues('observacoesPlacaBiosseguranca') : "",
			dispositivosBiossegurancaChecados: defaultForm.getValues('dispositivosBiossegurancaChecados') !== undefined ? defaultForm.getValues('dispositivosBiossegurancaChecados') : false,
			observacoesDispositivosBiossegurancaChecados: defaultForm.getValues('observacoesDispositivosBiossegurancaChecados') !== undefined ? defaultForm.getValues('observacoesDispositivosBiossegurancaChecados') : "",
			equipamentosAtividadePlantioLimpos: defaultForm.getValues('equipamentosAtividadePlantioLimpos') !== undefined ? defaultForm.getValues('equipamentosAtividadePlantioLimpos') : false,
			observacoesEquipamentosAtividadePlantioLimpos: defaultForm.getValues('observacoesEquipamentosAtividadePlantioLimpos') !== undefined ? defaultForm.getValues('observacoesEquipamentosAtividadePlantioLimpos') : "",
			tipoColheita_Id: defaultForm.getValues('tipoColheita_Id') !== undefined ? (defaultForm.getValues('tipoColheita_Id') as any).value : 0,
			embalagemArmazenamentoMateriais: defaultForm.getValues('embalagemArmazenamentoMateriais') !== undefined ? defaultForm.getValues('embalagemArmazenamentoMateriais') : false,
			observacoesEmbalagemArmazenamentoMateriais: defaultForm.getValues('observacoesEmbalagemArmazenamentoMateriais') !== undefined ? defaultForm.getValues('observacoesEmbalagemArmazenamentoMateriais') : "",
			materialColhidoEmbalado: defaultForm.getValues('materialColhidoEmbalado') !== undefined ? defaultForm.getValues('materialColhidoEmbalado') : false,
			observacoesMaterialColhidoEmbalado: defaultForm.getValues('observacoesMaterialColhidoEmbalado') !== undefined ? defaultForm.getValues('observacoesMaterialColhidoEmbalado') : "",
			restosVegetaisDevidamenteDescartados: defaultForm.getValues('restosVegetaisDevidamenteDescartados') !== undefined ? defaultForm.getValues('restosVegetaisDevidamenteDescartados') : false,
			observacoesRestosVegetaisDevidamenteDescartados: defaultForm.getValues('observacoesRestosVegetaisDevidamenteDescartados') !== undefined ? defaultForm.getValues('observacoesRestosVegetaisDevidamenteDescartados') : "",
		})

		return arrPlanejamentoConducao;
	}
	///* *//
	const expectedDatasPlantio = (): ExpectedDatasPlantio[] => {
		let arrDatasPlantio: ExpectedDatasPlantio[] = [];

		for (let count = 0, countLen = selectedDataPlantios.length; count < countLen; count++) {
			arrDatasPlantio.push({
				Id: 0,
				dataInicialPlantio: selectedDataPlantios[count].dataInicialPlantio !== undefined ? selectedDataPlantios[count].dataInicialPlantio : '',
				dataFinalPlantio: selectedDataPlantios[count].dataFinalPlantio !== undefined ? selectedDataPlantios[count].dataFinalPlantio : '',
			})
		}

		return arrDatasPlantio;
	}
	///* *//
	const expectedPessoasEnvolvidasPlantio = (): ExpectedPessoasEnvolvidasPlantio[] => {
		let arrPessoasEnvolvidasPlantio: ExpectedPessoasEnvolvidasPlantio[] = [];

		for (let count = 0, countLen = selectedPessoasEnvolvidasPlantio.length; count < countLen; count++) {
			arrPessoasEnvolvidasPlantio.push({
				Id: 0,
				pessoaPlantio: selectedPessoasEnvolvidasPlantio[count].pessoaPlantio !== undefined ? selectedPessoasEnvolvidasPlantio[count].pessoaPlantio : '',
			})
		}

		return arrPessoasEnvolvidasPlantio;
	}
	///* *//
	const expectedDatasColheita = (): ExpectedDatasColheita[] => {
		let arrDatasColheita: ExpectedDatasColheita[] = [];

		for (let count = 0, countLen = selectedDatasColheita.length; count < countLen; count++) {
			arrDatasColheita.push({
				Id: 0,
				dataColheita: selectedDatasColheita[count].dataColheita !== undefined ? selectedDatasColheita[count].dataColheita : '',
				dataInicialColheita: selectedDatasColheita[count].dataInicialColheita !== undefined ? selectedDatasColheita[count].dataInicialColheita : '',
				dataFinalColheita: selectedDatasColheita[count].dataFinalColheita !== undefined ? selectedDatasColheita[count].dataFinalColheita : '',
			})
		}

		return arrDatasColheita;
	}
	///* *//
	const expectedPessoasEnvolvidasColheita = (): ExpectedPessoasEnvolvidasColheita[] => {
		let arrPessoasEnvolvidasColheita: ExpectedPessoasEnvolvidasColheita[] = [];

		for (let count = 0, countLen = selectedPessoasEnvolvidasColheita.length; count < countLen; count++) {
			arrPessoasEnvolvidasColheita.push({
				Id: 0,
				pessoaColheita: selectedPessoasEnvolvidasColheita[count].pessoaColheita !== undefined ? selectedPessoasEnvolvidasColheita[count].pessoaColheita : '',
			})
		}

		return arrPessoasEnvolvidasColheita;
	}
	///* *//
	const expectedLimpeza = (): ExpectedLimpeza[] => {
		let arrLimpeza: ExpectedLimpeza[] = [];

		for (let count = 0, countLen = selectedLimpezaInstalacoes.length; count < countLen; count++) {
			arrLimpeza.push({
				Id: 0,
				dataLimpeza: selectedLimpezaInstalacoes[count].dataLimpeza !== undefined ? selectedLimpezaInstalacoes[count].dataLimpeza : '',
				numeroCodigoCasaVegetacao: selectedLimpezaInstalacoes[count].numeroCodigoCasaVegetacao !== undefined ? selectedLimpezaInstalacoes[count].numeroCodigoCasaVegetacao : '',
				responsavel: selectedLimpezaInstalacoes[count].responsavel !== undefined ? selectedLimpezaInstalacoes[count].responsavel : '',
				metodoLimpeza_Id: selectedLimpezaInstalacoes[count].metodoLimpeza_Id !== undefined ? selectedLimpezaInstalacoes[count].metodoLimpeza_Id.value : 0,
				outrosMetodoLimpeza: selectedLimpezaInstalacoes[count].outrosMetodoLimpeza !== undefined ? selectedLimpezaInstalacoes[count].outrosMetodoLimpeza : '',
			})
		}
		return arrLimpeza;
	}
	///* *//
	const expectedInspecao = (): ExpectedInspecao[] => {
		let arrInspecao: ExpectedInspecao[] = [];

		for (let count = 0, countLen = selectedInspecaoEquipamentos.length; count < countLen; count++) {
			arrInspecao.push({
				Id: 0,
				numeroPlantio: selectedInspecaoEquipamentos[count].numeroPlantio !== undefined ? selectedInspecaoEquipamentos[count].numeroPlantio : '',
				iD_Equipamento: selectedInspecaoEquipamentos[count].iD_Equipamento !== undefined ? selectedInspecaoEquipamentos[count].iD_Equipamento : '',
				dataAntesUso: selectedInspecaoEquipamentos[count].dataAntesUso !== undefined ? selectedInspecaoEquipamentos[count].dataAntesUso : '',
				dataAposUso: selectedInspecaoEquipamentos[count].dataAposUso !== undefined ? selectedInspecaoEquipamentos[count].dataAposUso : '',
				faseEnsaio: selectedInspecaoEquipamentos[count].faseEnsaio !== undefined ? selectedInspecaoEquipamentos[count].faseEnsaio : '',
				metodoLimpezaEquipamento_Id: selectedInspecaoEquipamentos[count].metodoLimpezaEquipamento_Id !== undefined ? selectedInspecaoEquipamentos[count].metodoLimpezaEquipamento_Id.value : 0,
				outrosMetodoLimpezaEquipamento: selectedInspecaoEquipamentos[count].outrosMetodoLimpezaEquipamento !== undefined ? selectedInspecaoEquipamentos[count].outrosMetodoLimpezaEquipamento : '',
				faseLimpeza_Id: selectedInspecaoEquipamentos[count].faseLimpeza_Id !== undefined ? selectedInspecaoEquipamentos[count].faseLimpeza_Id.value : 0,
			})
		}
		return arrInspecao;
	}
	///* *//
	const expectedAtividades = (): ExpectedAtividades[] => {
		let arrAtividades: ExpectedAtividades[] = [];

		for (let count = 0, countLen = selectedAtividadeManutencao.length; count < countLen; count++) {
			arrAtividades.push({
				Id: 0,
				dataAtividade: selectedAtividadeManutencao[count].dataAtividade !== undefined ? selectedAtividadeManutencao[count].dataAtividade : '',
				dataInicialAtividade: selectedAtividadeManutencao[count].dataInicialAtividade !== undefined ? selectedAtividadeManutencao[count].dataInicialAtividade : '',
				dataFinalAtividade: selectedAtividadeManutencao[count].dataFinalAtividade !== undefined ? selectedAtividadeManutencao[count].dataFinalAtividade : '',
				responsavel: selectedAtividadeManutencao[count].responsavel !== undefined ? selectedAtividadeManutencao[count].responsavel : '',
				atividadeManutencao_Id: selectedAtividadeManutencao[count].atividadeManutencao_Id !== undefined ? selectedAtividadeManutencao[count].atividadeManutencao_Id.value : 0,
				outrosAtividadeManutencao: selectedAtividadeManutencao[count].outrosAtividadeManutencao !== undefined ? selectedAtividadeManutencao[count].outrosAtividadeManutencao : '',
			})
		}
		return arrAtividades;
	}

	const expectedDestruicao = (): ExpectedDestruicao[] => {
		let arrDestruicao: ExpectedDestruicao[] = [];

		arrDestruicao.push({
			Id: 0,
			tipoDestruicao: tipoDestruicaoValue !== undefined ? tipoDestruicaoValue : (defaultForm.getValues('tipoDestruicao') !== undefined ? (defaultForm.getValues('tipoDestruicao') as any).value : 0),
			outrosTipoDestruicao: defaultForm.getValues('outrosTipoDestruicao') !== undefined ? defaultForm.getValues('outrosTipoDestruicao') : '',
			numeroAmostras: defaultForm.getValues('numeroAmostras') !== undefined ? defaultForm.getValues('numeroAmostras') : 0,
			pesoAmostras: defaultForm.getValues('pesoAmostras') !== undefined ? defaultForm.getValues('pesoAmostras') : 0,
			localDestruicao: localDestruicaoValue !== undefined ? localDestruicaoValue : (defaultForm.getValues('localDestruicao') !== undefined ? (defaultForm.getValues('localDestruicao') as any).value : 0),
			outrosLocalDestruicao: defaultForm.getValues('outrosLocalDestruicao') !== undefined ? defaultForm.getValues('outrosLocalDestruicao') : '',
			observacoesLocalDestruicao: defaultForm.getValues('observacoesLocalDestruicao') !== undefined ? defaultForm.getValues('observacoesLocalDestruicao') : '',
			metodoDestruicao: metodoDestruicaoValue !== undefined ? metodoDestruicaoValue : (defaultForm.getValues('metodoDestruicao') !== undefined ? (defaultForm.getValues('metodoDestruicao') as any).value : 0),
			outrosMetodoDestruicao: defaultForm.getValues('outrosMetodoDestruicao') !== undefined ? defaultForm.getValues('outrosMetodoDestruicao') : '',
			observacoesMetodoDestruicao: defaultForm.getValues('observacoesMetodoDestruicao') !== undefined ? defaultForm.getValues('observacoesMetodoDestruicao') : '',
			unidadeMedida: defaultForm.getValues('unidadeMedida') !== undefined ? defaultForm.getValues('unidadeMedida') : 0,

		})

		return arrDestruicao;
	}
	///* *//
	const expectedDestruicaoResponsaveis = (): ExpectedDestruicaoResponsaveis[] => {
		let arrDestruicaoResponsaveis: ExpectedDestruicaoResponsaveis[] = [];

		for (let count = 0, countLen = selectedResponsaveisDescarte.length; count < countLen; count++) {
			arrDestruicaoResponsaveis.push({
				Id: 0,
				responsavel: selectedResponsaveisDescarte[count].responsaveisDescarte !== undefined ? selectedResponsaveisDescarte[count].responsaveisDescarte : '',
			})
		}

		return arrDestruicaoResponsaveis;
	}
	///* *//
	const expectedDestruicaoLimpeza = (): ExpectedDestruicaoLimpeza[] => {
		let arrDestruicaoLimpeza: ExpectedDestruicaoLimpeza[] = [];

		for (let count = 0, countLen = selectedLimpezaDestruicao.length; count < countLen; count++) {
			arrDestruicaoLimpeza.push({
				id: 0,
				descricaoMaquinario: selectedLimpezaDestruicao[count].descricaoMaquinario !== undefined ? selectedLimpezaDestruicao[count].descricaoMaquinario : '',
				dataLimpezaAntesUso: selectedLimpezaDestruicao[count].dataLimpezaAntesUso !== undefined ? selectedLimpezaDestruicao[count].dataLimpezaAntesUso : '',
				dataLimpezaDepoisUso: selectedLimpezaDestruicao[count].dataLimpezaDepoisUso !== undefined ? selectedLimpezaDestruicao[count].dataLimpezaDepoisUso : '',
				responsavelLimpeza: selectedLimpezaDestruicao[count].responsavelLimpeza !== undefined ? selectedLimpezaDestruicao[count].responsavelLimpeza : '',
				metodoLimpeza_Id: selectedLimpezaDestruicao[count].metodoLimpeza !== undefined ? selectedLimpezaDestruicao[count].metodoLimpeza.value : 0,
				outrosMetodoLimpeza: selectedLimpezaDestruicao[count].outrosMetodoLimpeza !== undefined ? selectedLimpezaDestruicao[count].outrosMetodoLimpeza : '',
			})
		}

		return arrDestruicaoLimpeza;
	}

	const expectedReportes = (): ExpectedReportes[] => {
		let arrReportes: ExpectedReportes[] = [];

		if (defaultForm.getValues('liberacaoNaoIntencional') !== undefined) {
			arrReportes.push({
				Id: 0,
				liberacaoNaoIntencional: defaultForm.getValues('liberacaoNaoIntencional') !== undefined ? defaultForm.getValues('liberacaoNaoIntencional') : '',
				dataLiberacaoNaoIntencional: defaultForm.getValues('dataLiberacaoNaoIntencional') !== undefined ? defaultForm.getValues('dataLiberacaoNaoIntencional') : moment().toDate(),
				medidasCorrecaoLiberacaoNaoIntencional: defaultForm.getValues('medidasCorrecaoLiberacaoNaoIntencional') !== undefined ? defaultForm.getValues('medidasCorrecaoLiberacaoNaoIntencional') : '',
				nomeReporteLiberacaoNaoIntencional: defaultForm.getValues('nomeReporteLiberacaoNaoIntencional') !== undefined ? defaultForm.getValues('nomeReporteLiberacaoNaoIntencional') : '',
				cargoReporteLiberacaoNaoIntencional: defaultForm.getValues('cargoReporteLiberacaoNaoIntencional') !== undefined ? defaultForm.getValues('cargoReporteLiberacaoNaoIntencional') : '',
				dataReporteLiberacaoNaoIntencional: defaultForm.getValues('dataReporteLiberacaoNaoIntencional') !== undefined ? defaultForm.getValues('dataReporteLiberacaoNaoIntencional') : moment().toDate(),
			})
		}

		return arrReportes;
	}
	///* *//
	const expectedAnotacoes = (): ExpectedAnotacoes[] => {
		let arrAnotacoes: ExpectedAnotacoes[] = [];

		for (let count = 0, countLen = selectedAnotacoes.length; count < countLen; count++) {
			arrAnotacoes.push({
				Id: 0,
				responsavel: selectedAnotacoes[0].responsavel !== undefined ? selectedAnotacoes[0].responsavel : decoded.unique_name,
				dataAnotacao: selectedAnotacoes[0].dataAnotacao !== undefined ? selectedAnotacoes[0].dataAnotacao : moment().toDate(),
				anotacao: selectedAnotacoes[0].anotacao !== undefined ? selectedAnotacoes[0].anotacao : '',
			})
		}
		return arrAnotacoes;
	}
	///* *//
	const expectedPlanejamentoNotificacaoPlantio = (): ExpectedPlanejamentoNotificacaoPlantio[] => {
		let arrPlanejamentoNotificacaoPlantio: ExpectedPlanejamentoNotificacaoPlantio[] = [];

		for (let count = 0, countLen = selectedPlantios.length; count < countLen; count++) {
			arrPlanejamentoNotificacaoPlantio.push({
				Id: 0,
				numeroPlantio: selectedPlantios[count].numeroPlantio !== undefined ? selectedPlantios[count].numeroPlantio : '',
				casaVegetacaoModulo: selectedPlantios[count].casaVegetacaoModulo !== undefined ? selectedPlantios[count].casaVegetacaoModulo : '',
				material: selectedPlantios[count].material !== undefined ? selectedPlantios[count].material : '',
				informacoesAdicionaisMaterial: selectedPlantios[count].informacoesAdicionaisMaterial !== undefined ? selectedPlantios[count].informacoesAdicionaisMaterial : '',
				numeroAMI: selectedPlantios[count].numeroAMI !== undefined ? selectedPlantios[count].numeroAMI : '',
				sobraMaterial: selectedPlantios[count].sobraMaterial !== undefined ? selectedPlantios[count].sobraMaterial : false,
				numeroAmostrasRestantes: selectedPlantios[count].numeroAmostrasRestantes !== undefined ? selectedPlantios[count].numeroAmostrasRestantes : 0,
				quantidadeAmostrasRestantes: selectedPlantios[count].quantidadeAmostrasRestantes !== undefined ? selectedPlantios[count].quantidadeAmostrasRestantes : 0,
				destinoSobra_Id: selectedPlantios[count].destinoSobra !== undefined ? (selectedPlantios[count].destinoSobra as any).value : 0,
				destinoSobraOutros: selectedPlantios[count].destinoSobraOutros !== undefined ? selectedPlantios[count].destinoSobraOutros : '',
				entradaArmazenamento: selectedPlantios[count].entradaArmazenamento !== undefined ? selectedPlantios[count].entradaArmazenamento : false,
				informacoesAdicionais: selectedPlantios[count].informacoesAdicionais !== undefined ? selectedPlantios[count].informacoesAdicionais : '',
				dataInicialPlantio: selectedPlantios[count].dataInicialPlantio !== undefined ? selectedPlantios[count].dataInicialPlantio : '',
				dataFinalPlantio: selectedPlantios[count].dataFinalPlantio !== undefined ? selectedPlantios[count].dataFinalPlantio : '',

				responsaveis: selectedPlantios[count].responsaveis,
			})
		}

		return arrPlanejamentoNotificacaoPlantio;
	}

	const getValuesToSubmitDraft = () => {
		return getValuesToSubmit();

	//	return {
	//		id: 0,
	//		codigoaac: defaultForm.getValues('codigoaac') !== undefined ? defaultForm.getValues('codigoaac') : '',
	//		projeto: defaultForm.getValues('projeto') !== undefined ? defaultForm.getValues('projeto') : '',
	//		municipio_Id: defaultForm.getValues('municipio') !== undefined ? (defaultForm.getValues('municipio') as any).value : 0,
	//		cultura_Id: defaultForm.getValues('cultura') !== undefined ? (defaultForm.getValues('cultura') as any).value : 0,
	//		nomecientifico: defaultForm.getValues('nomeCientifico') !== undefined ? defaultForm.getValues('nomeCientifico') : '',
	//		numeromapa: defaultForm.getValues('numeroMAPA') !== undefined ? defaultForm.getValues('numeroMAPA') : '',
	//		responsavelRegulatorio_Id: defaultForm.getValues('responsavelRegulatorio') !== undefined ? (defaultForm.getValues('responsavelRegulatorio') as any).value : 0,
	//		tecnicoPrincipal_Id: defaultForm.getValues('tecnicoPrincipal') !== undefined ? (defaultForm.getValues('tecnicoPrincipal') as any).value : 0, 
	//	};
	}

	const acoesDadosPrincipaisAAC = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setDadosPrincipaisAAC([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setDadosPrincipaisAAC([...arr]);
			}} />
		</Fragment>
	)

	const acoesDadosPrincipaisListaTreinamento = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setDadosPrincipaisListaTreinamento([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setDadosPrincipaisListaTreinamento([...arr]);
			}} />
		</Fragment>
	)

	const acoesDadosPrincipaisLiberacaoQuarentena = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setDadosPrincipaisLiberacaoQuarentena([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setDadosPrincipaisLiberacaoQuarentena([...arr]);
			}} />
		</Fragment>
	)

	const acoesDadosPrincipaisParecerTecnico = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setDadosPrincipaisParecerTecnico([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setDadosPrincipaisParecerTecnico([...arr]);
			}} />
		</Fragment>
	)

	const submitArquivosDadosPrincipaisAAC = async (formArquivosData: any) => {
		const arquivo = extrairArquivoDoModal(formArquivosData);
		if (!arquivo) {
			return;
		}

		setModalAtivo('');
		setDadosPrincipaisAAC([...dadosPrincipaisAAC, arquivo]);
		setLblDadosPrincipaisAAC('Escolher arquivo');
		modalArquivo.reset();
	}

	const submitArquivosListaTreinamento = async (formArquivosData: any) => {
		const arquivo = extrairArquivoDoModal(formArquivosData);
		if (!arquivo) {
			return;
		}

		setModalAtivo('');
		setDadosPrincipaisListaTreinamento([...dadosPrincipaisListaTreinamento, arquivo]);
		setLblDadosPrincipaisListaTreinamento('Escolher arquivo');
		modalArquivo.reset();
	}

	const submitArquivosDadosPrincipaisParecerTecnico = async (formArquivosData: any) => {
		const arquivo = extrairArquivoDoModal(formArquivosData);
		if (!arquivo) {
			return;
		}

		setModalAtivo('');
		Object.defineProperty(arquivo, 'filename', { value: arquivo.name, writable: true });
		setDadosPrincipaisParecerTecnico([...dadosPrincipaisParecerTecnico, arquivo]);
		setLblDadosPrincipaisParecerTecnico('Escolher arquivo');
		modalArquivo.reset();
	}

	const submitArquivosLiberacaoQuarentena = async (formArquivosData: any) => {
		const arquivo = extrairArquivoDoModal(formArquivosData);
		if (!arquivo) {
			return;
		}

		setModalAtivo('');
		setDadosPrincipaisLiberacaoQuarentena([...dadosPrincipaisLiberacaoQuarentena, arquivo]);
		setLblDadosPrincipaisLiberacaoQuarentena('Escolher arquivo');
		modalArquivo.reset();
	}

	const downloadModelFileDadosPrincipaisParecerTecnico = async (file: Models.ModelFileRegister | undefined) => {
		if (file !== undefined) {
			try {
				apiFileDownload.get(`api/v1/caderno-conformidade/Vegetacao/download?path=${dadosPrincipaisParecerTecnico[0].path}`)
					.then((response) => {
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', dadosPrincipaisParecerTecnico[0].filename);
						document.body.appendChild(link);
						link.click();
					});

			} catch (error: any) {
				console.error(error);
			}
		}
	}

	const linkDownload = (props: any) => (
		<Fragment>
			<a href='#' onClick={(e) => { downloadArquivo(e, props.node.data) }}>
				Download
			</a>
		</Fragment>
	)

	let linkDownloadTermos =
		<a href="../../static/media/TermosCadernoVegetacaoCAGES.pdf" target="_blank">Download dos termos</a>;

	const extrairArquivoPendente = (arquivo: any): File | null => {
		if (arquivo?.file instanceof File) return arquivo.file;
		if (arquivo instanceof File) return arquivo;
		if (arquivo?.length > 0 && arquivo[0] instanceof File) return arquivo[0];
		return null;
	};

	const extrairArquivoDoModal = (formArquivosData: any): File | null => {
		const arquivosInput = formArquivosData?.arquivos;
		const arquivo = arquivosInput instanceof FileList
			? arquivosInput[0]
			: (Array.isArray(arquivosInput) ? arquivosInput[0] : arquivosInput);
		return arquivo instanceof File ? arquivo : null;
	};

	const baixarArquivoLocal = (file: File, nomeDownload?: string) => {
		const url = URL.createObjectURL(file);
		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', nomeDownload ?? file.name);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	};

	const downloadArquivo = (e: any, arquivo: any) => {
		e.preventDefault();

		const path = arquivo?.path ?? arquivo?.Path;
		const filename = arquivo?.filename ?? arquivo?.Filename ?? arquivo?.name ?? 'download';
		const arquivoLocal = extrairArquivoPendente(arquivo);

		if (arquivoLocal) {
			baixarArquivoLocal(arquivoLocal, filename !== 'download' ? filename : undefined);
			return;
		}

		if (path) {
			apiFileDownload.get(`api/v1/caderno-conformidade/Vegetacao/download?path=${encodeURIComponent(path)}`)
				.then((response) => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', filename);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					URL.revokeObjectURL(url);
				})
				.catch((error) => {
					console.error('Erro ao baixar arquivo:', error);
				});
		}
	}

	const getValuesToSubmit = () => {

		var vegetacaoId = entity?.id ?? 0;
		var aprovador = '';
		var dataDaAprovacao;
		var observacoes = '';
		var tecnicoPrincipalEntidade = entity?.tecnicoPrincipalNome;
	
		if (vegetacaoId === 0 && location.state?.id) {
			vegetacaoId = location.state.id;
		}


		if (isApprove) {
			aprovador = decoded.unique_name;
			dataDaAprovacao = moment().toDate();
		}

		if (isCorrection) {
			observacoes = reasonCorrection;
		}

		return {
			id: vegetacaoId !== 0 ? vegetacaoId : 0,
			status: statusCadernoConformidade ?? entity?.status ?? 0,
			requisitante: vegetacaoId !== 0 ? entity?.requisitante : decoded.unique_name,
			codigoaac: defaultForm.getValues('codigoaac') !== undefined ? defaultForm.getValues('codigoaac') : '',
			projeto: defaultForm.getValues('projeto') !== undefined ? defaultForm.getValues('projeto') : '',
			municipio_Id: defaultForm.getValues('municipio') !== undefined ? (defaultForm.getValues('municipio') as any).value : 0,
			municipioEntidade: {
				label: defaultForm.getValues('municipio') !== undefined ? (defaultForm.getValues('municipio') as any).label : '',
				value: defaultForm.getValues('municipio') !== undefined ? (defaultForm.getValues('municipio') as any).value : 0,
			},
			cultura_Id: defaultForm.getValues('cultura') !== undefined ? (defaultForm.getValues('cultura') as any).value : 0,
			culturaEntidade: {
				label: defaultForm.getValues('cultura') !== undefined ? (defaultForm.getValues('cultura') as any).label : '',
				value: defaultForm.getValues('cultura') !== undefined ? (defaultForm.getValues('cultura') as any).value : 0,
			},
			nomecientifico: defaultForm.getValues('nomeCientifico') !== undefined ? (defaultForm.getValues('nomeCientifico') as any).label : '',
			nomecientifico_Id: defaultForm.getValues('nomeCientifico') !== undefined ? (defaultForm.getValues('nomeCientifico') as any).value : 0,
			numeromapa: defaultForm.getValues('numeroMAPA') !== undefined ? defaultForm.getValues('numeroMAPA') : '',
			responsavelRegulatorio_Id: defaultForm.getValues('responsavelRegulatorio') !== undefined ? (defaultForm.getValues('responsavelRegulatorio') as any).value : 0,
			responsavelRegulatorioEntidade: {
				label: defaultForm.getValues('responsavelRegulatorio') !== undefined ? (defaultForm.getValues('responsavelRegulatorio') as any).label : '',
				value: defaultForm.getValues('responsavelRegulatorio') !== undefined ? (defaultForm.getValues('responsavelRegulatorio') as any).value : 0,
			},
			tecnicoPrincipal_Id: defaultForm.getValues('tecnicoPrincipal') !== undefined ? (defaultForm.getValues('tecnicoPrincipal') as any).value : 0,
			tecnicoPrincipalNome: tecnicoPrincipalEntidade,
			tecnicoPrincipalEntidade: {
				label: defaultForm.getValues('tecnicoPrincipal') !== undefined ? (defaultForm.getValues('tecnicoPrincipal') as any).label : '',
				value: defaultForm.getValues('tecnicoPrincipal') !== undefined ? (defaultForm.getValues('tecnicoPrincipal') as any).value : 0,
			},

			cienciaInstrucoes: defaultForm.getValues('cienciaInstrucoes') !== undefined ? defaultForm.getValues('cienciaInstrucoes') : false,

			dataConclusao: '',
			nomeAprovador: isCorrection ? decoded.unique_name : (aprovador ?? ''),
			dataAprovacao: dataDaAprovacao !== undefined ? dataDaAprovacao : '',
			observacoesAnaliseRegulatorio: observacoes ?? '',

			vegetacao_Documentos: expectedDocumentos(),
			vegetacao_Documentos_RegistroAmostragem: expectedRegistroAmostragem(),

			//codigoaac: defaultForm.getValues('codigoaac') !== undefined ? defaultForm.getValues('codigoaac') : '',
			//projeto: defaultForm.getValues('projeto') !== undefined ? defaultForm.getValues('projeto') : '',
			//municipio_Id: defaultForm.getValues('municipio') !== undefined ? (defaultForm.getValues('municipio') as any).value : 0,
			//cultura_Id: defaultForm.getValues('cultura') !== undefined ? (defaultForm.getValues('cultura') as any).value : 0,
			//nomecientifico: defaultForm.getValues('nomeCientifico') !== undefined ? defaultForm.getValues('nomeCientifico') : '',
			//numeromapa: defaultForm.getValues('numeroMAPA') !== undefined ? defaultForm.getValues('numeroMAPA') : '',
			//responsavelRegulatorio_Id: defaultForm.getValues('responsavelRegulatorio') !== undefined ? (defaultForm.getValues('responsavelRegulatorio') as any).value : 0,
			//tecnicoPrincipal_Id: defaultForm.getValues('tecnicoPrincipal') !== undefined ? (defaultForm.getValues('tecnicoPrincipal') as any).value : 0,
			//status: statusCadernoConformidade !== undefined ? statusCadernoConformidade : 0,
			//requisitante: requisitanteCadernoConformidade !== undefined ? requisitanteCadernoConformidade : '',
			//dataCriacao: dataCriacaoCadernoConformidade !== '' ? dataCriacaoCadernoConformidade : moment().toDate(),

			//dataConclusao: '',
			//nomeAprovador: aprovador !== undefined ? aprovador : '',
			//dataAprovacao: dataDaAprovacao !== undefined ? dataDaAprovacao : '',
			//observacoesAnaliseRegulatorio: observacoes !== undefined ? observacoes : '',

			//vegetacao_Documentos: expectedDocumentos(),
			//vegetacao_Documentos_RegistroAmostragem: expectedRegistroAmostragem(),

			//vegetacao_Planejamento: expectedPlanejamento(),
			//vegetacao_Planejamento_Conducao: expectedPlanejamentoConducao(),
			//vegetacao_Planejamento_DatasPlantio: expectedDatasPlantio(),
			//vegetacao_Planejamento_PessoasPlantio: expectedPessoasEnvolvidasPlantio(),
			//vegetacao_Planejamento_DatasColheita: expectedDatasColheita(),
			//vegetacao_Planejamento_PessoasColheita: expectedPessoasEnvolvidasColheita(),
			//vegetacao_Planejamento_NotificacaoPlantio: expectedPlanejamentoNotificacaoPlantio(),
			//vegetacao_Planejamento_Limpeza: expectedLimpeza(),
			//vegetacao_Planejamento_Inspecao: expectedInspecao(),
			//vegetacao_Planejamento_Atividades: expectedAtividades(),

			//vegetacao_Destruicao: expectedDestruicao(),
			//vegetacao_Destruicao_Responsaveis: expectedDestruicaoResponsaveis(),
			//vegetacao_Destruicao_Limpeza: expectedDestruicaoLimpeza(),

			//vegetacao_Reportes: expectedReportes(),
			//vegetacao_Anotacoes: expectedAnotacoes(),


		};
	}

	const submitFilesRegistroAmostragem = async (cadernoConformidadeVegetacao_Id: number) => {

		if (selectedRegistroAmostragem.length > 0) {

			const arquivoRegistroAmostragem = selectedRegistroAmostragem[0].filename;

			if (arquivoRegistroAmostragem && arquivoRegistroAmostragem.length) {
				var formDataFiles = new FormData();

				for (let index = 0; index < arquivoRegistroAmostragem.length; index++) {
					const arquivo = arquivoRegistroAmostragem[index];

					formDataFiles.append('arquivos', arquivo);
				}

				const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarListaArquivosRegistroAmostragem`, formDataFiles);
				return status;
			}
		}

		return 200;
	}

	const submitFilesPastaProcesso = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosPastaProcesso = documentosGerais;

		if (arquivosPastaProcesso && arquivosPastaProcesso.length) {
			var formDataFiles = new FormData();

			for (let index = 0; index < arquivosPastaProcesso.length; index++) {
				const arquivo = arquivosPastaProcesso[index];

				formDataFiles.append('arquivos', arquivo);
			}

			const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarListaArquivosPastaProcesso`, formDataFiles);
			return status;
		}

		return 200;
	}

	const submitFilesDadosPrincipaisAAC = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosAAC = dadosPrincipaisAAC;

		if (arquivosAAC && arquivosAAC.length) {
			var formDataFiles = new FormData();

			for (let index = 0; index < arquivosAAC.length; index++) {
				const arquivo = arquivosAAC[index];

				formDataFiles.append('arquivos', arquivo);
			}

			const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarArquivoAACDadosPrincipais`, formDataFiles);
			return status;
		}

		return 200;
	}

	const submitFilesDadosPrincipaisListaTreinamentos = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosListaTreinamento = dadosPrincipaisListaTreinamento;

		if (arquivosListaTreinamento && arquivosListaTreinamento.length) {
			var formDataFiles = new FormData();

			for (let index = 0; index < arquivosListaTreinamento.length; index++) {
				const arquivo = arquivosListaTreinamento[index];

				formDataFiles.append('arquivos', arquivo);
			}

			const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarArquivosListaTreinamento`, formDataFiles);
			return status;
		}

		return 200;
	}

	const submitFilesDadosPrincipaisParecerTecnico = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosParecerTecnico = dadosPrincipaisParecerTecnico;

		if (arquivosParecerTecnico && arquivosParecerTecnico.length) {
			var formDataFiles = new FormData();

			for (let index = 0; index < arquivosParecerTecnico.length; index++) {
				const arquivo = arquivosParecerTecnico[index];

				if (arquivo instanceof File) {
					formDataFiles.append('arquivos', arquivo);
				}
			}

			const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarParecerTecnicoDadosPrincipais`, formDataFiles);
			return status;
		}

		return 200;
	}

	const submitFilesDadosPrincipaisLiberacaoQuarentenas = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosLiberacaoQuarentena = dadosPrincipaisLiberacaoQuarentena;

		if (arquivosLiberacaoQuarentena && arquivosLiberacaoQuarentena.length) {
			var formDataFiles = new FormData();

			for (let index = 0; index < arquivosLiberacaoQuarentena.length; index++) {
				const arquivo = arquivosLiberacaoQuarentena[index];

				if (arquivo instanceof File) {
					formDataFiles.append('arquivos', arquivo);
				}
			}

			const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarArquivosLiberacaoQuarentena`, formDataFiles);
			return status;
		}

		return 200;
	}

	const submitFilesAMI = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosAMI = numeroAMI;

		if (arquivosAMI && arquivosAMI.length) {
			var formDataFiles = new FormData();

			for (let index = 0; index < arquivosAMI.length; index++) {
				const arquivo = arquivosAMI[index];

				formDataFiles.append('arquivos', arquivo);
			}

			const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarListaArquivosAMI`, formDataFiles);
			return status;
		}

		return 200;
	}

	const submitFilesAAC = async (cadernoConformidadeVegetacao_Id: number) => {

		const arquivosAAC = numeroAAC;

		if (arquivosAAC && arquivosAAC.length) {
			var formDataFiles = new FormData();

			for (let index = 0; index < arquivosAAC.length; index++) {
				const arquivo = arquivosAAC[index];

				formDataFiles.append('arquivos', arquivo);
			}

			const { status } = await api.post(`api/v1/caderno-conformidade/Vegetacao/${cadernoConformidadeVegetacao_Id}/SalvarListaArquivosAAC`, formDataFiles);
			return status;
		}

		return 200;
	}

	const verifyErrorsOnForm = (): string[] => {
		let errorsForm: any[] = [];

		if (!isEmptyObj(errors)) {
			Object.entries(errors).map(err => errorsForm.push(err[0]));
		}
		return errorsForm;
	}

	const onSubmitDraft = async () => {
		setErrorDraft(null);
		setLoadingDraft(true);

		try {
			const vegetacaoToSubmitDraft = getValuesToSubmitDraft();
			const { status, data } = await api.post('api/v1/caderno-conformidade/Vegetacao/rascunho', vegetacaoToSubmitDraft);

			if (status === 201) {

				window.scrollTo({ top: 0, behavior: 'smooth' });
				setSuccessDraft(true);
				setTimeout(() => {
					history.push('/cadernoconformidade/consultar/vegetacao', { id: data.id });
				}, 3000)

			}
		} catch (error: any) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
			setErrorDraft(error.response?.data || error.message || "Erro ao salvar rascunho");
		} finally {
			setLoadingDraft(false);
		}
	}

	const onSubmit = async () => {
		setErrorSubmit(null);
		setLoadingSubmit(true);

		try {

			const vegetacaoToSubmit = getValuesToSubmit();
			const { status, data } = await api.post('api/v1/caderno-conformidade/Vegetacao/criacaoenviarregulatorio', vegetacaoToSubmit);

			if (status === 200 || status === 201) {
				setEntity(data);
				setStatusCadernoConformidade(data.status);
				submitFilesPastaProcesso(data.id)
					.then((fileStatus) => {
						if (fileStatus === 200) {
							submitFilesRegistroAmostragem(data.id)
								.then((fileStatus) => {
									if (fileStatus === 200) {
										submitFilesAMI(data.id)
											.then((fileStatus) => {
												if (fileStatus === 200) {
													submitFilesAAC(data.id)
														.then((fileStatus) => {
															if (fileStatus === 200) {
																submitFilesDadosPrincipaisAAC(data.id);
																submitFilesDadosPrincipaisParecerTecnico(data.id);
																submitFilesDadosPrincipaisListaTreinamentos(data.id);
																submitFilesDadosPrincipaisLiberacaoQuarentenas(data.id);
																window.scrollTo({ top: 0, behavior: 'smooth' });
																setSuccessDraft(true);
																setTimeout(() => {
																	history.push('/cadernoconformidade/consultar/vegetacao', { id: data.id });
																}, 4900)
															}
														})
												}
											})
									}
								})
						}
					})
			}

		} catch (error: any) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
			setErrorSubmit(error.response.data);
			setIsRegulatory(false);
		}

		setLoadingSubmit(false);
	}    

	const requestCorrection = async () => {
		setLoadingCorrection(true);
		setErrorSubmit(null);

		try {
			const valuesToSubmit = getValuesToSubmit();
			const { status, data } = await api.post('api/v1/caderno-conformidade/Vegetacao/solicitarcorrecao', valuesToSubmit);

			if (status === 200 || status === 201) {
				getCadernoConformidade(data.id);
				setStatusCadernoConformidade(data.status);
				setSuccessCorrection(true);
				setTimeout(() => {
					setIsCorrection(false);
					history.push('/cadernoconformidade/consultar/vegetacao', { id: data.id });
				}, 4900);
				window.scrollTo({ top: 0, behavior: 'smooth' });
			}
		} catch (error: any) {
			setErrorSubmit(error.response.data);
			setIsCorrection(false);
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
		setLoadingCorrection(false);
	}

	const submitForm_aprove = async () => {
		setLoadingApprove(true);
		setErrorSubmit(null);
		try {

			const valuesToSubmit = getValuesToSubmit();

			if (valuesToSubmit.id === 0)
			{
				const { status, data } = await api.post('api/v1/caderno-conformidade/Vegetacao/criacaoenviarregulatorio', valuesToSubmit);

				if (status === 200 || status === 201) {
					submitFilesDadosPrincipaisAAC(data.id);
					submitFilesDadosPrincipaisParecerTecnico(data.id);
					submitFilesDadosPrincipaisListaTreinamentos(data.id);
					submitFilesDadosPrincipaisLiberacaoQuarentenas(data.id);
					window.scrollTo({ top: 0, behavior: 'smooth' });
					setSuccessDraft(true);
					setTimeout(() => {
						history.push('/cadernoconformidade/consultar/vegetacao', { id: data.id });
					}, 4900)
				}
			}
			else
			{
				const { status, data } = await api.post('api/v1/caderno-conformidade/Vegetacao/aprovar', valuesToSubmit);

				if (status === 200 || status === 201) {
					setEntity(data);
					setStatusCadernoConformidade(data.status);
					aplicarDocumentosNoForm(data?.vegetacao_Documentos?.[0]);
					setSuccessApprove(true);
					setTimeout(() => {
						setIsApprove(false);
						history.push('/cadernoconformidade/consultar/vegetacao', { id: data.id });
					}, 4900);
					window.scrollTo({ top: 0, behavior: 'smooth' });
				}
			}

		} catch (error: any) {
			const errData = error?.response?.data;
			setErrorSubmit(errData?.message ?? errData ?? error.message);
			setIsApprove(false);
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
		setLoadingApprove(false);
	}


	let BotoesFases =
		<div className="button-position tab-buttons-local">

			{/*<Button*/}
			{/*	title="Dados Principais/Documentos"*/}
			{/*	contained={false}*/}
			{/*	className={modoFluxo === MODO_VIEW.DADOS_PRINCIPAIS ? "active" : ''}*/}
			{/*	type="button"*/}
			{/*	onClick={() => {*/}
			{/*		gravarDados(modoFluxo);*/}
			{/*		setModoFluxo(MODO_VIEW.DADOS_PRINCIPAIS);*/}
			{/*	}}*/}
			{/*/>*/}

			{/*<Button*/}
			{/*	title="Planejamento/Condução"*/}
			{/*	className={modoFluxo === MODO_VIEW.PLANEJAMENTO ? "active" : ''}*/}
			{/*	contained={false}*/}
			{/*	type="button"*/}
			{/*	onClick={() => {*/}
			{/*		gravarDados(modoFluxo);*/}
			{/*		setModoFluxo(MODO_VIEW.PLANEJAMENTO);*/}
			{/*	}}*/}
			{/*/>*/}

			{/*<Button*/}
			{/*	title="Destruição/Descarte"*/}
			{/*	className={modoFluxo === MODO_VIEW.DESCARTE ? "active" : ''}*/}
			{/*	contained={false}*/}
			{/*	type="button"*/}
			{/*	onClick={() => {*/}
			{/*		gravarDados(modoFluxo);*/}
			{/*		setModoFluxo(MODO_VIEW.DESCARTE);*/}
			{/*	}}*/}
			{/*/>*/}

			{/*<Button*/}
			{/*	title="Reportes/Anotações"*/}
			{/*	className={modoFluxo === MODO_VIEW.NOTAS ? "active" : ''}*/}
			{/*	contained={false}*/}
			{/*	type="button"*/}
			{/*	onClick={() => {*/}
			{/*		gravarDados(modoFluxo);*/}
			{/*		setModoFluxo(MODO_VIEW.NOTAS);*/}
			{/*	}}*/}
			{/*/>*/}
		</div>;

	const statusAtual = statusCadernoConformidade ?? entity?.status;
	const temCadernoExistente = !!(entity?.id || location.state?.id);
	const exibirSolicitarCriacaoRequisitante =
		(isRequesterWriter(decoded.roles) || (!isReguladorWriter(decoded.roles) && !isAdmin(decoded.roles)))
		&& podeRequisitanteSolicitarCriacaoCaderno(statusAtual, temCadernoExistente);

	return <div className="container-custom-search">
		<h3>{STRINGS_CADERNOCONFORMIDADE.REGISTER_CADERNO_CONFORMIDADE_VEGETACAO}</h3>
		{/*<Form onSubmit={defaultForm.handleSubmit(submitForm_salvar)}>*/}
		<Form>
			{BotoesFases}
			<If condition={modoFluxo === MODO_VIEW.DADOS_PRINCIPAIS}>
				<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_ONE}>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={5}>
							<Form.Label>Projeto<em>*</em></Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="projeto"
								placeholder="Insira o nome do projeto"
								maxLength={100}
								defaultValue={entity?.projeto}
							/>
						</Form.Group>
						<Form.Group as={Col} md={5}>
							<Form.Label>Municipio<em>*</em></Form.Label>
							<Controller
								control={defaultForm.control}
								name="municipio"
								required

								isInvalid={defaultForm.errors.municipio_Id !== undefined}
								as={<Select
									placeholder="Selecione o município"
									options={enumMunicipio.map(municipio => Object.assign({ value: municipio.key, label: municipio.value }))}
									isClearable
								/>}
							/>
							<If condition={defaultForm.errors.municipio_Id}>
								<span className="error-field">{defaultForm.errors.municipio_Id?.message}</span>
							</If>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>
								Cultura<em>*</em>
							</Form.Label>
							<Controller
								control={defaultForm.control}
								name="cultura"
								required
								defaultValue={getValues('cultura')}
								isInvalid={defaultForm.errors.cultura_Id !== undefined}
								as={<Select
									options={cultures.map(culture => Object.assign({ label: culture.nome, value: culture.id }))}
									placeholder="Selecione uma cultura/organismo"
									isClearable
								/>}
							/>
							<If condition={errors.cultura_Id}>
								<span className="error-field">{errors.cultura_Id?.message}</span>
							</If>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Nome Científico<em>*</em></Form.Label>
							<Controller
								control={defaultForm.control}
								name="nomeCientifico"
								required

								isInvalid={defaultForm.errors.municipio_Id !== undefined}
								as={<Select
									placeholder="Selecione o Nome Científico"
									options={enumNomeCientifico.map(nomeCientifico => Object.assign({ value: nomeCientifico.key, label: nomeCientifico.value }))}
									isClearable
								/>}
							/>

						{/*	<Form.Control*/}
						{/*		ref={defaultForm.register}*/}
						{/*		name="nomeCientifico"*/}
						{/*		placeholder="Insira o nome científico da cultura"*/}
						{/*		maxLength={100}*/}
						{/*		defaultValue={entity?.nomecientifico}*/}

						{/*	/>*/}
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>AAC<em>*</em></Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="codigoaac"
								placeholder="Insira o código da AAC"
								maxLength={100}
								defaultValue={entity?.codigoaac}

							/>
							<LinkVisualizarAutorizacao tipo="aac" codigo={defaultForm.watch('codigoaac')} />
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Nº MAPA (IP/Autorização Importação)<em>*</em></Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="numeroMAPA"
								placeholder="Insira o número do MAPA (IP Autorização Importação) em caso de semente importada."
								maxLength={100}
								defaultValue={entity?.numeromapa}

							/>
						</Form.Group>
					</Form.Row>
					<Form.Row className="row-custom">
						<Form.Group as={Col} md={6}>
							<Form.Label>Responsável Regulatório<em>*</em></Form.Label>
							<Controller
								control={defaultForm.control}
								name="responsavelRegulatorio"
								required

								isInvalid={defaultForm.errors.responsavelRegulatorio_Id !== undefined}
								as={<Select
									options={enumResponsavelRegulatorio.map(responsavel => Object.assign({ label: responsavel.value, value: responsavel.key }))}
									placeholder="Selecione um responsável do Regulatório"
									isClearable
								/>}
							/>
						</Form.Group>
						<Form.Group as={Col} md={6}>
							<Form.Label>Técnico Principal<em>*</em></Form.Label>
							<Controller
								control={defaultForm.control}
								name="tecnicoPrincipal"
								required

								isInvalid={defaultForm.errors.tecnicoPrincipal_Id !== undefined}
								as={<Select
									options={tecnicoPrincipal.map(tecnico => Object.assign({ label: tecnico.nome, value: tecnico.id }))}
									placeholder="Selecione um técnico principal"
									isClearable
								/>}
							/>
						</Form.Group>
					</Form.Row>
				</Fieldset>

				<Fieldset disabled={false} title={STRINGS_CADERNOCONFORMIDADE.BLOCK_TWO}>

					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>
								Documentos Obrigatórios
								{/*	<br />*/}
								{/*	<br />*/}
								{/*	<AddButton type="button" onClick={() => setModalAtivo('DOCUMENTOS_GERAIS')} />*/}
							</Form.Label>
							<If condition={eventMsg}>
								<p className="error-field">{STRINGS.FORM_FIELD_REQUIRED}</p>
							</If>
						</Form.Group>
					</Form.Row>
					{/*<If condition={documentosGerais.length}>*/}
					{/*	<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>*/}
					{/*		<AgGridReact*/}
					{/*			rowData={documentosGerais}*/}
					{/*			defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}*/}
					{/*			gridOptions={{ headerHeight: 80 }}*/}
					{/*			stopEditingWhenGridLosesFocus={true}*/}
					{/*			singleClickEdit={true}*/}
					{/*			frameworkComponents={{*/}
					{/*				actions: acoesDocumentosGerais,*/}
					{/*				linkPastaProcesso: linkDownload*/}
					{/*			}}*/}
					{/*		>*/}
					{/*			<AgGridColumn*/}
					{/*				headerName='Nome'*/}
					{/*				headerClass="myfunc-default-header"*/}
					{/*				field="name"*/}
					{/*				cellStyle={{*/}
					{/*					justifyContent: 'left'*/}
					{/*				}}*/}
					{/*				autoHeight*/}
					{/*				wrapText*/}
					{/*				minWidth={250}*/}
					{/*			/>*/}
					{/*			<AgGridColumn*/}
					{/*				headerName='Link'*/}
					{/*				headerClass="myfunc-default-header"*/}
					{/*				cellRenderer="linkPastaProcesso"*/}
					{/*				field="name"*/}
					{/*				cellStyle={{*/}
					{/*					justifyContent: 'left'*/}
					{/*				}}*/}
					{/*				autoHeight*/}
					{/*				wrapText*/}
					{/*				minWidth={250}*/}
					{/*			/>*/}
					{/*			<AgGridColumn*/}
					{/*				headerName="Ações"*/}
					{/*				headerClass="myfunc-default-header"*/}
					{/*				cellRenderer="actions"*/}
					{/*				maxWidth={100}*/}
					{/*			/>*/}
					{/*		</AgGridReact>*/}
					{/*	</div>*/}
					{/*</If>*/}

					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							{renderCheckboxField('copiaAAC', 'Conferência AAC/CIBio')}
						</Form.Group>
					</Form.Row>
					<If condition={dadosPrincipaisAAC.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={dadosPrincipaisAAC}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesDadosPrincipaisAAC,
									linkPastaProcesso: linkDownload
								}}
							>
								<AgGridColumn
									headerName='Arquivo'
									headerClass="myfunc-default-header"
									field="name"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName='Link'
									headerClass="myfunc-default-header"
									cellRenderer="linkPastaProcesso"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									maxWidth={100}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>

							</AgGridReact>
						</div>
						{/*<Form.Row className="row-custom">*/}
						{/*	<Form.Group as={Col}>*/}
						{/*		<FileExistent text={dadosPrincipaisAAC[0]?.filename}*/}
						{/*			onDownload={(e: any) => {*/}
						{/*				e.preventDefault();*/}
						{/*				downloadModelFileDadosPrincipaisAAC(fileFieldDadosPrincipaisAAC);*/}
						{/*			}}*/}
						{/*			onClick={() => {*/}
						{/*				setFileFieldDadosPrincipaisAAC({ id: null, codigo: '', dataAtualizacao: '', nome: '', path: '', usuario: '' });*/}
						{/*			}}*/}
						{/*		/>*/}
						{/*	</Form.Group>*/}
						{/*</Form.Row>*/}
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Observações</Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="observacoesCopiaAAC"
								as="textarea"
								rows={4}
								placeholder="Informar número da AAC e data de aprovação"
								defaultValue={entity?.observacoesCopiaAAC}
							/>
						</Form.Group>
					</Form.Row>

					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							{renderCheckboxField('copiaListaTreinamentos', 'Conferência e Upload Listas de Treinamento de Biossegurança')}
						</Form.Group>
						<Form.Group as={Col}>
							<AddButton type="button" onClick={() => setModalAtivo('LISTA_TREINAMENTO_DADOS_PRINCIPAIS')} />
						</Form.Group>

					</Form.Row>
					<If condition={dadosPrincipaisListaTreinamento.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={dadosPrincipaisListaTreinamento}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesDadosPrincipaisListaTreinamento,
									linkPastaProcesso: linkDownload
								}}
							>
								<AgGridColumn
									headerName='Arquivo'
									headerClass="myfunc-default-header"
									field="name"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName='Link'
									headerClass="myfunc-default-header"
									cellRenderer="linkPastaProcesso"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									maxWidth={100}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Observações</Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="observacoesCopiaListaTreinamentos"
								as="textarea"
								rows={4}
								placeholder="Insira observações adicionais, se pertinente"
								defaultValue={entity?.observacoesCopiaListaTreinamentos}
							/>
						</Form.Group>
					</Form.Row>

					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							{renderCheckboxField('copiaParecerTecnicoCTNBio', 'Conferência e Upload do Último Parecer Técnico CTNBio')}
						</Form.Group>
						<Form.Group as={Col}>
							<AddButton type="button" onClick={() => setModalAtivo('PARECER_TECNICO_DADOS_PRINCIPAIS')} />
						</Form.Group>

					</Form.Row>
				<If condition={dadosPrincipaisParecerTecnico.length}>
					<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
						<AgGridReact
							rowData={dadosPrincipaisParecerTecnico}
							defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
							gridOptions={{ headerHeight: 80 }}
							stopEditingWhenGridLosesFocus={true}
							singleClickEdit={true}
							frameworkComponents={{
								actions: acoesDadosPrincipaisParecerTecnico,
								linkPastaProcesso: linkDownload
							}}
						>
							<AgGridColumn
								headerName='Arquivo'
								headerClass="myfunc-default-header"
								field="name"
								cellStyle={{
									justifyContent: 'left'
								}}
								autoHeight
								wrapText
								minWidth={250}
							/>
							<AgGridColumn
								headerName='Link'
								headerClass="myfunc-default-header"
								cellRenderer="linkPastaProcesso"
								field="name"
								cellStyle={{
									justifyContent: 'left'
								}}
								autoHeight
								wrapText
								maxWidth={100}
							/>
							<AgGridColumn
								headerName="Ações"
								headerClass="myfunc-default-header"
								cellRenderer="actions"
								maxWidth={100}
							/>
						</AgGridReact>
					</div>
				</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Observações</Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="observacoesCopiaCTNBio"
								as="textarea"
								rows={4}
								placeholder="Insira observações adicionais, se pertinente"
								defaultValue={entity?.vegetacao_Documentos?.[0]?.observacoesCopiaCTNBio ?? entity?.vegetacao_Documentos?.[0]?.observacoesCopiaParecerTecnicoCTNBio}
							/>
						</Form.Group>
					</Form.Row>

					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							{renderCheckboxField('copiaQuarentena', 'Origem das sementes - Permissão de Importação, Liberação da Quarentena e/ou AAC para sementes produzidas localmente')}
						</Form.Group>
						<Form.Group as={Col}>
							<AddButton type="button" onClick={() => setModalAtivo('LIBERACAO_QUARENTENA_DADOS_PRINCIPAIS')} />
						</Form.Group>
					</Form.Row>
					<If condition={dadosPrincipaisLiberacaoQuarentena.length}>
						<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
							<AgGridReact
								rowData={dadosPrincipaisLiberacaoQuarentena}
								defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
								gridOptions={{ headerHeight: 80 }}
								stopEditingWhenGridLosesFocus={true}
								singleClickEdit={true}
								frameworkComponents={{
									actions: acoesDadosPrincipaisLiberacaoQuarentena,
									linkPastaProcesso: linkDownload
								}}
							>
								<AgGridColumn
									headerName='Arquivo'
									headerClass="myfunc-default-header"
									field="name"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									minWidth={250}
								/>
								<AgGridColumn
									headerName='Link'
									headerClass="myfunc-default-header"
									cellRenderer="linkPastaProcesso"
									field="name"
									cellStyle={{
										justifyContent: 'left'
									}}
									autoHeight
									wrapText
									maxWidth={100}
								/>
								<AgGridColumn
									headerName="Ações"
									headerClass="myfunc-default-header"
									cellRenderer="actions"
									maxWidth={100}
								/>
							</AgGridReact>
						</div>
					</If>
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>Observações</Form.Label>
							<Form.Control
								ref={defaultForm.register}
								name="observacoesCopiaQuarentena"
								as="textarea"
								rows={4}
								placeholder="Informar número do PI, Número do Ofício de Liberação e Data"
								defaultValue={entity?.observacoesCopiaQuarentena}
							/>
						</Form.Group>
					</Form.Row>

					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							{renderCheckboxField('cienciaInstrucoes', 'Declaro estar ciente das instruções regulatórias sobre a legislação e normas de Biossegurança para condução de ensaios e atividades em Casa-de-Vegetação, e que no surgimento de qualquer dúvida ou problema durante a condução do ensaio/atividade  entrarei em contato imediatamente com o Departamento Regulatório e CIBio BASF')}
						</Form.Group>
						<Form.Group as={Col}>
							{linkDownloadTermos}
						</Form.Group>
					</Form.Row>
				</Fieldset>
			</If>

			<div className="button-position">
				<Button
					title="Voltar"
					contained={false}
					type="button"
					onClick={() => {
						isDirty ? setIsConfirmation(true) :
							history.goBack();
					}}
				/>
				<If condition={exibirSolicitarCriacaoRequisitante}>
					<Button
						title={statusAtual === STATUS_CADERNOCONFORMIDADE.CorrecaoCriacaoSolicitada
							? 'Reenviar Criação do Caderno Digital'
							: 'Solicitar Criação do Caderno Digital'}
						contained={true}
						type="button"
						onClick={() => setIsRegulatory(true)}
						isLoading={loadingDraft}
					/>
				</If>
				<If condition={(isReguladorWriter(decoded.roles) || isAdmin(decoded.roles)) && isCriacaoEmAnaliseRegulatorio(statusAtual ?? 0)}>
					<GenericButton
						title="Solicitar Correção na Criação do Caderno Digital"
						variant="btn-danger"
						type="button"
						loading={false}
						onClick={() => setIsCorrection(true)}
					/>
					<GenericButton
						title="Aprovar Criação de Caderno Digital"
						variant="btn-success"
						type="button"
						loading={false}
						onClick={() => setIsApprove(true)}
					/>
				</If>
			</div>
			<If condition={isRegulatory}>
				<ConfirmationModal
					show={isRegulatory}
					onHide={() => {
						setIsRegulatory(false);
					}}
					title={STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_ENVIO_CIBIO_TITLE}
					confirmationMsg={STRINGS.REGULATORY_ACTION}
					onConfirm={() => {
						onSubmit();
					}}
					loading={loadingSubmit}
					variant="success"
					color="white"
				>
					<p>{STRINGS.REGULATORY_MESSAGE}</p>
				</ConfirmationModal>
			</If>
			<If condition={isCorrection}>
				<ConfirmationModal
					show={isCorrection}
					onHide={() => setIsCorrection(false)}
					title={STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_CORRECTION_TITLE}
					confirmationMsg={STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_CORRECTION_CONFIRMATION_MSG}
					onConfirm={() => requestCorrection()}
					loading={loadingCorrection}
					variant="success"
					color="white"
					hideFooter={successCorrection}
				>
					<If condition={successCorrection}>
						<AlertSuccess
							message={STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_CORRECTION_SUCCESS}
						/>
					</If>
					<p>{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_CORRECTION_BODY_MSG}</p>
					<Form.Label>
						Motivo da Correção:<em>*</em>
					</Form.Label>
					<Form.Control
						onChange={({ target }: any) =>
							setReasonCorrection(target.value)
						}
						value={reasonCorrection}
						as="textarea"
						maxLength={200}
					/>
				</ConfirmationModal>
			</If>
			<If condition={isApprove}>
				<ConfirmationModal
					show={isApprove}
					onHide={() => setIsApprove(false)}
					title={STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_APROVE_TITLE}
					confirmationMsg={STRINGS.APROVE_CONFIRMATION}
					onConfirm={() => submitForm_aprove()}
					loading={loadingApprove}
					variant="success"
					color="white"
					hideFooter={successApprove}
				>
					<If condition={successApprove}>
						<AlertSuccess
							message={STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_APROVE_SUCCESS}
						/>
					</If>
					<p>{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_APROVE_BODY_MSG}</p>
				</ConfirmationModal>
			</If>

			{/*Modal Arquivo AAC*/}
			<If condition={modalAtivo === 'AAC_DADOS_PRINCIPAIS'}>
				<Modal show={true} onHide={() => setModalAtivo('')} title={'Adicionar arquivo de AAC'}>
					<Form onSubmit={modalArquivo.handleSubmit(submitArquivosDadosPrincipaisAAC)} autoComplete="off">
						<Form.Group as={Col} md={6}>
							<Form.Label>
								Anexar Documento<em>*</em>
							</Form.Label>
							<Form.File
								ref={modalArquivo.register}
								name="arquivos"
								label={lblDadosPrincipaisAAC}
								data-browse="upload"
								custom
								onChange={({ target }: any) => {
									if (!target.value) {
										return
									}
									setLblDadosPrincipaisAAC(`${target.files[0].name}`);
								}}
							/>
						</Form.Group>
						<div className="button-position">
							<Button title="Cancelar" contained={false} type="button" onClick={() => setModalAtivo('')} />
							<Button title="Inserir" contained={true} type="submit" />
						</div>
					</Form>
				</Modal>
			</If>

			{/*Modal Arquivo Lista Treinamento*/}
			<If condition={modalAtivo === 'LISTA_TREINAMENTO_DADOS_PRINCIPAIS'}>
				<Modal show={true} onHide={() => setModalAtivo('')} title={'Adicionar arquivo de Lista de Treinamento'}>
					<Form onSubmit={modalArquivo.handleSubmit(submitArquivosListaTreinamento)} autoComplete="off">
						<Form.Group as={Col} md={6}>
							<Form.Label>
								Anexar Documento<em>*</em>
							</Form.Label>
							<Form.File
								ref={modalArquivo.register}
								name="arquivos"
								label={lblDadosPrincipaisListaTreinamento}
								data-browse="upload"
								custom
								onChange={({ target }: any) => {
									if (!target.value) {
										return
									}
									setLblDadosPrincipaisListaTreinamento(`${target.files[0].name}`);
								}}
							/>
						</Form.Group>
						<div className="button-position">
							<Button title="Cancelar" contained={false} type="button" onClick={() => setModalAtivo('')} />
							<Button title="Inserir" contained={true} type="submit" />
						</div>
					</Form>
				</Modal>
			</If>

			{/*Modal Arquivo Parecer Técnico*/}
			<If condition={modalAtivo === 'PARECER_TECNICO_DADOS_PRINCIPAIS'}>
				<Modal show={true} onHide={() => setModalAtivo('')} title={'Adicionar arquivo de Parecer Técnico'}>
					<Form onSubmit={modalArquivo.handleSubmit(submitArquivosDadosPrincipaisParecerTecnico)} autoComplete="off">
						<Form.Group as={Col} md={6}>
							<Form.Label>
								Anexar Documento<em>*</em>
							</Form.Label>
							<Form.File
								ref={modalArquivo.register}
								name="arquivos"
								label={lblDadosPrincipaisParecerTecnico}
								data-browse="upload"
								custom
								onChange={({ target }: any) => {
									if (!target.value) {
										return
									}
									setLblDadosPrincipaisParecerTecnico(`${target.files[0].name}`);
								}}
							/>
						</Form.Group>
						<div className="button-position">
							<Button title="Cancelar" contained={false} type="button" onClick={() => setModalAtivo('')} />
							<Button title="Inserir" contained={true} type="submit" />
						</div>
					</Form>
				</Modal>
			</If>

			{/*Modal Arquivo Liberação Quarentena*/}
			<If condition={modalAtivo === 'LIBERACAO_QUARENTENA_DADOS_PRINCIPAIS'}>
				<Modal show={true} onHide={() => setModalAtivo('')} title={'Adicionar arquivo de Liberação de Quarentena'}>
					<Form onSubmit={modalArquivo.handleSubmit(submitArquivosLiberacaoQuarentena)} autoComplete="off">
						<Form.Group as={Col} md={6}>
							<Form.Label>
								Anexar Documento<em>*</em>
							</Form.Label>
							<Form.File
								ref={modalArquivo.register}
								name="arquivos"
								label={lblDadosPrincipaisLiberacaoQuarentena}
								data-browse="upload"
								custom
								onChange={({ target }: any) => {
									if (!target.value) {
										return
									}
									setLblDadosPrincipaisLiberacaoQuarentena(`${target.files[0].name}`);
								}}
							/>
						</Form.Group>
						<div className="button-position">
							<Button title="Cancelar" contained={false} type="button" onClick={() => setModalAtivo('')} />
							<Button title="Inserir" contained={true} type="submit" />
						</div>
					</Form>
				</Modal>
			</If>

		</Form>

	</div>


	
}